webpackJsonp([35783957827783],{

/***/ 887:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserLocale = exports.getUserLocales = undefined;
	
	var _lodash = __webpack_require__(1300);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var filterDuplicates = function filterDuplicates(arr) {
	  return arr.filter(function (el, index, self) {
	    return self.indexOf(el) === index;
	  });
	};
	
	var fixLowercaseProperties = function fixLowercaseProperties(arr) {
	  return arr.map(function (el) {
	    if (!el || !el.includes('-') || el.toLowerCase() !== el) {
	      return el;
	    }
	
	    var splitEl = el.split('-');
	    return splitEl[0] + '-' + splitEl[1].toUpperCase();
	  });
	};
	
	var getUserLocales = exports.getUserLocales = (0, _lodash2.default)(function () {
	  var languageList = [];
	
	  if (typeof window !== 'undefined') {
	    if (window.navigator.languages) {
	      languageList.push.apply(languageList, _toConsumableArray(window.navigator.languages));
	    }
	    if (window.navigator.language) {
	      languageList.push(window.navigator.language);
	    }
	    if (window.navigator.userLanguage) {
	      languageList.push(window.navigator.userLanguage);
	    }
	    if (window.navigator.browserLanguage) {
	      languageList.push(window.navigator.browserLanguage);
	    }
	    if (window.navigator.systemLanguage) {
	      languageList.push(window.navigator.systemLanguage);
	    }
	  }
	
	  languageList.push('en-US'); // Fallback
	
	  return fixLowercaseProperties(filterDuplicates(languageList));
	});
	
	var getUserLocale = exports.getUserLocale = (0, _lodash2.default)(function () {
	  return getUserLocales()[0];
	});
	
	exports.default = getUserLocale;

/***/ }),

/***/ 1300:
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = once;


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var mergeClassNames = function mergeClassNames() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args.reduce(function (classList, arg) {
	    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
	  }, []).filter(function (className) {
	    return className;
	  }).join(' ');
	};
	
	exports.default = mergeClassNames;

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(1493);
	
	var _mergeClassNames = __webpack_require__(258);
	
	var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);
	
	var _Navigation = __webpack_require__(1412);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _CenturyView = __webpack_require__(262);
	
	var _CenturyView2 = _interopRequireDefault(_CenturyView);
	
	var _DecadeView = __webpack_require__(263);
	
	var _DecadeView2 = _interopRequireDefault(_DecadeView);
	
	var _YearView = __webpack_require__(265);
	
	var _YearView2 = _interopRequireDefault(_YearView);
	
	var _MonthView = __webpack_require__(264);
	
	var _MonthView2 = _interopRequireDefault(_MonthView);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	var _utils = __webpack_require__(266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var allViews = ['century', 'decade', 'year', 'month'];
	var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);
	
	var datesAreDifferent = function datesAreDifferent(date1, date2) {
	  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
	};
	
	/**
	 * Returns views array with disallowed values cut off.
	 */
	var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
	  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
	};
	
	var getView = function getView(view, minDetail, maxDetail) {
	  if (view && getLimitedViews(minDetail, maxDetail).indexOf(view) !== -1) {
	    return view;
	  }
	
	  return getLimitedViews(minDetail, maxDetail).pop();
	};
	
	/**
	 * Determines whether a given view is allowed with currently applied settings.
	 */
	var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
	  var views = getLimitedViews(minDetail, maxDetail);
	
	  return views.indexOf(view) !== -1;
	};
	
	/**
	 * Returns value type that can be returned with currently applied settings.
	 */
	var getValueType = function getValueType(maxDetail) {
	  return allValueTypes[allViews.indexOf(maxDetail)];
	};
	
	var getValueFrom = function getValueFrom(value) {
	  if (!value) {
	    return null;
	  }
	
	  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;
	
	  if (!rawValueFrom) {
	    return null;
	  }
	
	  var valueFromDate = new Date(rawValueFrom);
	
	  if (isNaN(valueFromDate.getTime())) {
	    throw new Error('Invalid date: ' + value);
	  }
	
	  return valueFromDate;
	};
	
	var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
	  var valueFrom = getValueFrom(value);
	
	  if (!valueFrom) {
	    return null;
	  }
	
	  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
	
	  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
	};
	
	var getValueTo = function getValueTo(value) {
	  if (!value) {
	    return null;
	  }
	
	  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;
	
	  if (!rawValueTo) {
	    return null;
	  }
	
	  var valueToDate = new Date(rawValueTo);
	
	  if (isNaN(valueToDate.getTime())) {
	    throw new Error('Invalid date: ' + value);
	  }
	
	  return valueToDate;
	};
	
	var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
	  var valueTo = getValueTo(value);
	
	  if (!valueTo) {
	    return null;
	  }
	
	  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
	
	  return (0, _utils.between)(detailValueTo, minDate, maxDate);
	};
	
	var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
	  if (value instanceof Array) {
	    return value;
	  }
	
	  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
	};
	
	var getActiveStartDate = function getActiveStartDate(props) {
	  var activeStartDate = props.activeStartDate,
	      maxDate = props.maxDate,
	      maxDetail = props.maxDetail,
	      minDate = props.minDate,
	      minDetail = props.minDetail,
	      value = props.value,
	      view = props.view;
	
	
	  var rangeType = getView(view, minDetail, maxDetail);
	  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
	  return (0, _dates.getBegin)(rangeType, valueFrom);
	};
	
	var Calendar = function (_Component) {
	  _inherits(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.setActiveStartDate = function (activeStartDate) {
	      var onActiveDateChange = _this.props.onActiveDateChange;
	
	
	      _this.setState({ activeStartDate: activeStartDate }, function () {
	        var view = _this.state.view;
	
	
	        (0, _utils.callIfDefined)(onActiveDateChange, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    }, _this.drillDown = function (activeStartDate) {
	      if (!_this.drillDownAvailable) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          maxDetail = _this$props.maxDetail,
	          minDetail = _this$props.minDetail,
	          onDrillDown = _this$props.onDrillDown;
	
	
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      _this.setState(function (prevState) {
	        var nextView = views[views.indexOf(prevState.view) + 1];
	        return {
	          activeStartDate: activeStartDate,
	          view: nextView
	        };
	      }, function () {
	        var view = _this.state.view;
	
	
	        (0, _utils.callIfDefined)(onDrillDown, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    }, _this.drillUp = function () {
	      if (!_this.drillUpAvailable) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          maxDetail = _this$props2.maxDetail,
	          minDetail = _this$props2.minDetail,
	          onDrillUp = _this$props2.onDrillUp;
	
	
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      _this.setState(function (prevState) {
	        var nextView = views[views.indexOf(prevState.view) - 1];
	        var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);
	
	        return {
	          activeStartDate: activeStartDate,
	          view: nextView
	        };
	      }, function () {
	        var _this$state = _this.state,
	            activeStartDate = _this$state.activeStartDate,
	            view = _this$state.view;
	
	
	        (0, _utils.callIfDefined)(onDrillUp, {
	          activeStartDate: activeStartDate,
	          view: view
	        });
	      });
	    }, _this.onChange = function (value) {
	      var _this$props3 = _this.props,
	          onChange = _this$props3.onChange,
	          selectRange = _this$props3.selectRange;
	
	
	      var nextValue = void 0;
	      var callback = void 0;
	      if (selectRange) {
	        var previousValue = _this.state.value;
	        // Range selection turned on
	
	        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
	        ) {
	            // First value
	            nextValue = (0, _dates.getBegin)(_this.valueType, value);
	          } else {
	          // Second value
	          nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);
	          callback = function callback() {
	            return (0, _utils.callIfDefined)(onChange, nextValue);
	          };
	        }
	      } else {
	        // Range selection turned off
	        nextValue = _this.getProcessedValue(value);
	        callback = function callback() {
	          return (0, _utils.callIfDefined)(onChange, nextValue);
	        };
	      }
	
	      _this.setState({ value: nextValue }, callback);
	    }, _this.onMouseOver = function (value) {
	      _this.setState({ hover: value });
	    }, _this.onMouseOut = function () {
	      _this.setState({ hover: null });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Calendar, [{
	    key: 'getProcessedValue',
	
	
	    /**
	     * Gets current value in a desired format.
	     */
	    value: function getProcessedValue(value) {
	      var _props = this.props,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          maxDetail = _props.maxDetail,
	          returnValue = _props.returnValue;
	
	
	      switch (returnValue) {
	        case 'start':
	          return getDetailValueFrom(value, minDate, maxDate, maxDetail);
	        case 'end':
	          return getDetailValueTo(value, minDate, maxDate, maxDetail);
	        case 'range':
	          return getDetailValueArray(value, minDate, maxDate, maxDetail);
	        default:
	          throw new Error('Invalid returnValue.');
	      }
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props2 = this.props,
	          calendarType = _props2.calendarType,
	          locale = _props2.locale,
	          maxDate = _props2.maxDate,
	          minDate = _props2.minDate,
	          renderChildren = _props2.renderChildren,
	          selectRange = _props2.selectRange,
	          tileClassName = _props2.tileClassName,
	          tileContent = _props2.tileContent,
	          tileDisabled = _props2.tileDisabled;
	      var _state = this.state,
	          activeStartDate = _state.activeStartDate,
	          hover = _state.hover,
	          value = _state.value,
	          view = _state.view;
	      var onMouseOver = this.onMouseOver,
	          valueType = this.valueType;
	
	
	      var commonProps = {
	        activeStartDate: activeStartDate,
	        hover: hover,
	        locale: locale,
	        maxDate: maxDate,
	        minDate: minDate,
	        onMouseOver: selectRange ? onMouseOver : null,
	        tileClassName: tileClassName,
	        tileContent: tileContent || renderChildren, // For backwards compatibility
	        tileDisabled: tileDisabled,
	        value: value,
	        valueType: valueType
	      };
	
	      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;
	
	      switch (view) {
	        case 'century':
	          {
	            var onClickDecade = this.props.onClickDecade;
	
	
	            return _react2.default.createElement(_CenturyView2.default, _extends({
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
	            }, commonProps));
	          }
	        case 'decade':
	          {
	            var onClickYear = this.props.onClickYear;
	
	
	            return _react2.default.createElement(_DecadeView2.default, _extends({
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
	            }, commonProps));
	          }
	        case 'year':
	          {
	            var _props3 = this.props,
	                formatMonth = _props3.formatMonth,
	                onClickMonth = _props3.onClickMonth;
	
	
	            return _react2.default.createElement(_YearView2.default, _extends({
	              formatMonth: formatMonth,
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
	            }, commonProps));
	          }
	        case 'month':
	          {
	            var _props4 = this.props,
	                formatShortWeekday = _props4.formatShortWeekday,
	                onClickDay = _props4.onClickDay,
	                onClickWeekNumber = _props4.onClickWeekNumber,
	                showFixedNumberOfWeeks = _props4.showFixedNumberOfWeeks,
	                showNeighboringMonth = _props4.showNeighboringMonth,
	                showWeekNumbers = _props4.showWeekNumbers;
	
	
	            return _react2.default.createElement(_MonthView2.default, _extends({
	              calendarType: calendarType,
	              formatShortWeekday: formatShortWeekday,
	              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
	              onClickWeekNumber: onClickWeekNumber,
	              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
	              showNeighboringMonth: showNeighboringMonth,
	              showWeekNumbers: showWeekNumbers
	            }, commonProps));
	          }
	        default:
	          throw new Error('Invalid view: ' + view + '.');
	      }
	    }
	  }, {
	    key: 'renderNavigation',
	    value: function renderNavigation() {
	      var showNavigation = this.props.showNavigation;
	
	
	      if (!showNavigation) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          formatMonthYear = _props5.formatMonthYear,
	          locale = _props5.locale,
	          maxDate = _props5.maxDate,
	          maxDetail = _props5.maxDetail,
	          minDate = _props5.minDate,
	          minDetail = _props5.minDetail,
	          next2Label = _props5.next2Label,
	          nextLabel = _props5.nextLabel,
	          navigationLabel = _props5.navigationLabel,
	          prev2Label = _props5.prev2Label,
	          prevLabel = _props5.prevLabel;
	      var _state2 = this.state,
	          activeRange = _state2.activeRange,
	          activeStartDate = _state2.activeStartDate,
	          view = _state2.view;
	
	
	      return _react2.default.createElement(_Navigation2.default, {
	        activeRange: activeRange,
	        activeStartDate: activeStartDate,
	        drillUp: this.drillUp,
	        formatMonthYear: formatMonthYear,
	        locale: locale,
	        maxDate: maxDate,
	        minDate: minDate,
	        next2Label: next2Label,
	        nextLabel: nextLabel,
	        navigationLabel: navigationLabel,
	        prev2Label: prev2Label,
	        prevLabel: prevLabel,
	        setActiveStartDate: this.setActiveStartDate,
	        view: view,
	        views: getLimitedViews(minDetail, maxDetail)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          className = _props6.className,
	          selectRange = _props6.selectRange;
	      var value = this.state.value;
	      var onMouseOut = this.onMouseOut;
	
	      var valueArray = [].concat(value);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _mergeClassNames2.default)('react-calendar', selectRange && valueArray.length === 1 && 'react-calendar--selectRange', className),
	          onMouseOut: selectRange ? onMouseOut : null,
	          onBlur: selectRange ? onMouseOut : null
	        },
	        this.renderNavigation(),
	        this.renderContent()
	      );
	    }
	  }, {
	    key: 'drillDownAvailable',
	    get: function get() {
	      var _props7 = this.props,
	          maxDetail = _props7.maxDetail,
	          minDetail = _props7.minDetail;
	      var view = this.state.view;
	
	
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      return views.indexOf(view) < views.length - 1;
	    }
	  }, {
	    key: 'drillUpAvailable',
	    get: function get() {
	      var _props8 = this.props,
	          maxDetail = _props8.maxDetail,
	          minDetail = _props8.minDetail;
	      var view = this.state.view;
	
	
	      var views = getLimitedViews(minDetail, maxDetail);
	
	      return views.indexOf(view) > 0;
	    }
	  }, {
	    key: 'valueType',
	    get: function get() {
	      var maxDetail = this.props.maxDetail;
	
	
	      return getValueType(maxDetail);
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var minDate = nextProps.minDate,
	          maxDate = nextProps.maxDate,
	          minDetail = nextProps.minDetail,
	          maxDetail = nextProps.maxDetail;
	
	
	      var nextState = {};
	
	      /**
	       * If the next activeStartDate is different from the current one, update
	       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
	       */
	      var nextActiveStartDate = getActiveStartDate(nextProps);
	      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
	        nextState.activeStartDate = nextActiveStartDate;
	        nextState.activeStartDateProps = nextActiveStartDate;
	      }
	
	      /**
	       * If the next view is different from the current one, and the previously set view is not
	       * valid based on minDetail and maxDetail, get a new one.
	       */
	      var nextView = getView(nextProps.view, minDetail, maxDetail);
	      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
	        nextState.view = nextView;
	        nextState.viewProps = nextView;
	      }
	
	      /**
	       * If the next value is different from the current one (with an exception of situation in
	       * which values provided are limited by minDate and maxDate so that the dates are the same),
	       * get a new one.
	       */
	      var values = [nextProps.value, prevState.valueProps];
	      if (nextState.view // Allowed view changed
	      || datesAreDifferent.apply(undefined, _toConsumableArray(values.map(function (value) {
	        return getValueFrom(value, minDate, maxDate, maxDetail);
	      }))) || datesAreDifferent.apply(undefined, _toConsumableArray(values.map(function (value) {
	        return getValueTo(value, minDate, maxDate, maxDetail);
	      })))) {
	        nextState.value = nextProps.value;
	        nextState.valueProps = nextProps.value;
	      }
	
	      if (!nextProps.selectRange && prevState.hover) {
	        nextState.hover = null;
	      }
	
	      return nextState;
	    }
	
	    /**
	     * Called when the user uses navigation buttons.
	     */
	
	  }]);
	
	  return Calendar;
	}(_react.Component);
	
	exports.default = Calendar;
	
	
	Calendar.defaultProps = {
	  maxDetail: 'month',
	  minDetail: 'century',
	  returnValue: 'start',
	  showNavigation: true,
	  showNeighboringMonth: true,
	  view: 'month'
	};
	
	Calendar.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date),
	  calendarType: _propTypes3.isCalendarType,
	  className: _propTypes3.isClassName,
	  formatMonth: _propTypes2.default.func,
	  formatMonthYear: _propTypes2.default.func,
	  formatShortWeekday: _propTypes2.default.func,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes3.isMaxDate,
	  maxDetail: _propTypes2.default.oneOf(allViews),
	  minDate: _propTypes3.isMinDate,
	  minDetail: _propTypes2.default.oneOf(allViews),
	  navigationLabel: _propTypes2.default.func,
	  next2Label: _propTypes2.default.node,
	  nextLabel: _propTypes2.default.node,
	  onActiveDateChange: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onClickDay: _propTypes2.default.func,
	  onClickDecade: _propTypes2.default.func,
	  onClickMonth: _propTypes2.default.func,
	  onClickWeekNumber: _propTypes2.default.func,
	  onClickYear: _propTypes2.default.func,
	  onDrillDown: _propTypes2.default.func,
	  onDrillUp: _propTypes2.default.func,
	  prev2Label: _propTypes2.default.node,
	  prevLabel: _propTypes2.default.node,
	  renderChildren: _propTypes2.default.func, // For backwards compatibility
	  returnValue: _propTypes2.default.oneOf(['start', 'end', 'range']),
	  selectRange: _propTypes2.default.bool,
	  showFixedNumberOfWeeks: _propTypes2.default.bool,
	  showNavigation: _propTypes2.default.bool,
	  showNeighboringMonth: _propTypes2.default.bool,
	  showWeekNumbers: _propTypes2.default.bool,
	  tileClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes3.isClassName]),
	  tileContent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  tileDisabled: _propTypes2.default.func,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes3.isValue]),
	  view: _propTypes2.default.oneOf(allViews)
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Calendar);

/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dates = __webpack_require__(24);
	
	var _dateFormatter = __webpack_require__(169);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Navigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.onClickPrevious = function () {
	      var _this$props = _this.props,
	          date = _this$props.activeStartDate,
	          view = _this$props.view,
	          setActiveStartDate = _this$props.setActiveStartDate;
	
	      setActiveStartDate((0, _dates.getBeginPrevious)(view, date));
	    }, _this.onClickNext = function () {
	      var _this$props2 = _this.props,
	          date = _this$props2.activeStartDate,
	          view = _this$props2.view,
	          setActiveStartDate = _this$props2.setActiveStartDate;
	
	      setActiveStartDate((0, _dates.getBeginNext)(view, date));
	    }, _this.onClickPrevious2 = function () {
	      var _this$props3 = _this.props,
	          date = _this$props3.activeStartDate,
	          view = _this$props3.view,
	          setActiveStartDate = _this$props3.setActiveStartDate;
	
	      setActiveStartDate((0, _dates.getBeginPrevious2)(view, date));
	    }, _this.onClickNext2 = function () {
	      var _this$props4 = _this.props,
	          date = _this$props4.activeStartDate,
	          view = _this$props4.view,
	          setActiveStartDate = _this$props4.setActiveStartDate;
	
	      setActiveStartDate((0, _dates.getBeginNext2)(view, date));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Navigation, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          locale = _props.locale,
	          view = _props.view;
	
	
	      return nextProps.activeStartDate !== activeStartDate || nextProps.locale !== locale || nextProps.view !== view;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var label = this.label;
	      var _props2 = this.props,
	          date = _props2.activeStartDate,
	          drillUp = _props2.drillUp,
	          navigationLabel = _props2.navigationLabel,
	          next2Label = _props2.next2Label,
	          nextLabel = _props2.nextLabel,
	          prev2Label = _props2.prev2Label,
	          prevLabel = _props2.prevLabel,
	          view = _props2.view;
	
	
	      var className = 'react-calendar__navigation';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: { display: 'flex' }
	        },
	        prev2Label !== null && view !== 'century' && _react2.default.createElement(
	          'button',
	          {
	            className: className + '__arrow ' + className + '__prev2-button',
	            disabled: this.prev2ButtonDisabled,
	            onClick: this.onClickPrevious2,
	            type: 'button'
	          },
	          prev2Label
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: className + '__arrow ' + className + '__prev-button',
	            disabled: this.prevButtonDisabled,
	            onClick: this.onClickPrevious,
	            type: 'button'
	          },
	          prevLabel
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'react-calendar__navigation__label',
	            onClick: drillUp,
	            disabled: !this.drillUpAvailable,
	            style: { flexGrow: 1 },
	            type: 'button'
	          },
	          navigationLabel ? navigationLabel({ date: date, view: view, label: label }) : label
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: className + '__arrow ' + className + '__next-button',
	            disabled: this.nextButtonDisabled,
	            onClick: this.onClickNext,
	            type: 'button'
	          },
	          nextLabel
	        ),
	        next2Label !== null && view !== 'century' && _react2.default.createElement(
	          'button',
	          {
	            className: className + '__arrow ' + className + '__next2-button',
	            disabled: this.next2ButtonDisabled,
	            onClick: this.onClickNext2,
	            type: 'button'
	          },
	          next2Label
	        )
	      );
	    }
	  }, {
	    key: 'drillUpAvailable',
	    get: function get() {
	      var _props3 = this.props,
	          view = _props3.view,
	          views = _props3.views;
	
	      return views.indexOf(view) > 0;
	    }
	  }, {
	    key: 'prevButtonDisabled',
	    get: function get() {
	      var _props4 = this.props,
	          date = _props4.activeStartDate,
	          minDate = _props4.minDate,
	          view = _props4.view;
	
	      var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
	      if (previousActiveStartDate.getFullYear() < 1000) {
	        return true;
	      }
	      var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
	      return minDate && minDate >= previousActiveEndDate;
	    }
	  }, {
	    key: 'prev2ButtonDisabled',
	    get: function get() {
	      var _props5 = this.props,
	          date = _props5.activeStartDate,
	          minDate = _props5.minDate,
	          view = _props5.view;
	
	      var previousActiveStartDate = (0, _dates.getBeginPrevious2)(view, date);
	      if (previousActiveStartDate.getFullYear() < 1000) {
	        return true;
	      }
	      var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
	      return minDate && minDate >= previousActiveEndDate;
	    }
	  }, {
	    key: 'nextButtonDisabled',
	    get: function get() {
	      var _props6 = this.props,
	          date = _props6.activeStartDate,
	          maxDate = _props6.maxDate,
	          view = _props6.view;
	
	      var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
	      return maxDate && maxDate <= nextActiveStartDate;
	    }
	  }, {
	    key: 'next2ButtonDisabled',
	    get: function get() {
	      var _props7 = this.props,
	          date = _props7.activeStartDate,
	          maxDate = _props7.maxDate,
	          view = _props7.view;
	
	      var nextActiveStartDate = (0, _dates.getBeginNext2)(view, date);
	      return maxDate && maxDate <= nextActiveStartDate;
	    }
	  }, {
	    key: 'label',
	    get: function get() {
	      var _props8 = this.props,
	          date = _props8.activeStartDate,
	          formatMonthYear = _props8.formatMonthYear,
	          locale = _props8.locale,
	          view = _props8.view;
	
	
	      switch (view) {
	        case 'century':
	          return (0, _dates.getCenturyLabel)(date);
	        case 'decade':
	          return (0, _dates.getDecadeLabel)(date);
	        case 'year':
	          return (0, _dates.getYear)(date);
	        case 'month':
	          return formatMonthYear(date, locale);
	        default:
	          throw new Error('Invalid view: ' + view + '.');
	      }
	    }
	  }]);
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	
	
	Navigation.defaultProps = {
	  formatMonthYear: _dateFormatter.formatMonthYear,
	  next2Label: '»',
	  nextLabel: '›',
	  prev2Label: '«',
	  prevLabel: '‹'
	};
	
	Navigation.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  drillUp: _propTypes2.default.func.isRequired,
	  formatMonthYear: _propTypes2.default.func,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes2.default.instanceOf(Date),
	  minDate: _propTypes2.default.instanceOf(Date),
	  next2Label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  nextLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  navigationLabel: _propTypes2.default.func,
	  prev2Label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  prevLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
	  setActiveStartDate: _propTypes2.default.func.isRequired,
	  view: _propTypes3.isView.isRequired,
	  views: _propTypes3.isViews.isRequired
	};

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Decades = __webpack_require__(1414);
	
	var _Decades2 = _interopRequireDefault(_Decades);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CenturyView = function (_PureComponent) {
	  _inherits(CenturyView, _PureComponent);
	
	  function CenturyView() {
	    _classCallCheck(this, CenturyView);
	
	    return _possibleConstructorReturn(this, (CenturyView.__proto__ || Object.getPrototypeOf(CenturyView)).apply(this, arguments));
	  }
	
	  _createClass(CenturyView, [{
	    key: 'renderDecades',
	    value: function renderDecades() {
	      return _react2.default.createElement(_Decades2.default, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-calendar__century-view' },
	        this.renderDecades()
	      );
	    }
	  }]);
	
	  return CenturyView;
	}(_react.PureComponent);
	
	exports.default = CenturyView;
	
	
	CenturyView.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  maxDate: _propTypes3.isMaxDate,
	  minDate: _propTypes3.isMinDate,
	  onChange: _propTypes2.default.func,
	  setActiveRange: _propTypes2.default.func,
	  value: _propTypes3.isValue,
	  valueType: _propTypes2.default.string
	};

/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tile = __webpack_require__(111);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var className = 'react-calendar__century-view__decades__decade';
	
	var Decade = function Decade(_ref) {
	  var classes = _ref.classes,
	      point = _ref.point,
	      otherProps = _objectWithoutProperties(_ref, ['classes', 'point']);
	
	  return _react2.default.createElement(
	    _Tile2.default,
	    _extends({}, otherProps, {
	      classes: [].concat(_toConsumableArray(classes), [className]),
	      dateTime: point + 'T00:00:00.000',
	      maxDateTransform: _dates.getEndOfDecade,
	      minDateTransform: _dates.getBeginOfDecade,
	      view: 'century'
	    }),
	    (0, _dates.getDecadeLabel)(point)
	  );
	};
	
	Decade.propTypes = _extends({
	  point: _propTypes2.default.number.isRequired
	}, _propTypes3.tileProps);
	
	exports.default = Decade;

/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TileGroup = __webpack_require__(112);
	
	var _TileGroup2 = _interopRequireDefault(_TileGroup);
	
	var _Decade = __webpack_require__(1413);
	
	var _Decade2 = _interopRequireDefault(_Decade);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Decades = function (_PureComponent) {
	  _inherits(Decades, _PureComponent);
	
	  function Decades() {
	    _classCallCheck(this, Decades);
	
	    return _possibleConstructorReturn(this, (Decades.__proto__ || Object.getPrototypeOf(Decades)).apply(this, arguments));
	  }
	
	  _createClass(Decades, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          otherProps = _objectWithoutProperties(_props, ['activeStartDate']);
	
	      return _react2.default.createElement(_TileGroup2.default, _extends({}, otherProps, {
	        className: 'react-calendar__century-view__decades',
	        dateTransform: _dates.getBeginOfDecade,
	        dateType: 'decade',
	        end: this.end,
	        start: this.start,
	        step: 10,
	        tile: _Decade2.default
	      }));
	    }
	  }, {
	    key: 'start',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getBeginOfCenturyYear)(activeStartDate);
	    }
	  }, {
	    key: 'end',
	    get: function get() {
	      return this.start + 99;
	    }
	  }]);
	
	  return Decades;
	}(_react.PureComponent);
	
	exports.default = Decades;
	
	
	Decades.propTypes = _extends({}, _propTypes.tileGroupProps);

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Years = __webpack_require__(1416);
	
	var _Years2 = _interopRequireDefault(_Years);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DecadeView = function (_PureComponent) {
	  _inherits(DecadeView, _PureComponent);
	
	  function DecadeView() {
	    _classCallCheck(this, DecadeView);
	
	    return _possibleConstructorReturn(this, (DecadeView.__proto__ || Object.getPrototypeOf(DecadeView)).apply(this, arguments));
	  }
	
	  _createClass(DecadeView, [{
	    key: 'renderYears',
	    value: function renderYears() {
	      return _react2.default.createElement(_Years2.default, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-calendar__decade-view' },
	        this.renderYears()
	      );
	    }
	  }]);
	
	  return DecadeView;
	}(_react.PureComponent);
	
	exports.default = DecadeView;
	
	
	DecadeView.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  maxDate: _propTypes3.isMaxDate,
	  minDate: _propTypes3.isMinDate,
	  onChange: _propTypes2.default.func,
	  setActiveRange: _propTypes2.default.func,
	  value: _propTypes3.isValue,
	  valueType: _propTypes2.default.string
	};

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tile = __webpack_require__(111);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var className = 'react-calendar__decade-view__years__year';
	
	var Year = function Year(_ref) {
	  var classes = _ref.classes,
	      point = _ref.point,
	      otherProps = _objectWithoutProperties(_ref, ['classes', 'point']);
	
	  return _react2.default.createElement(
	    _Tile2.default,
	    _extends({}, otherProps, {
	      classes: [].concat(_toConsumableArray(classes), [className]),
	      dateTime: point + 'T00:00:00.000',
	      maxDateTransform: _dates.getEndOfYear,
	      minDateTransform: _dates.getBeginOfYear,
	      view: 'decade'
	    }),
	    point
	  );
	};
	
	Year.propTypes = _extends({
	  point: _propTypes2.default.number.isRequired
	}, _propTypes3.tileProps);
	
	exports.default = Year;

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TileGroup = __webpack_require__(112);
	
	var _TileGroup2 = _interopRequireDefault(_TileGroup);
	
	var _Year = __webpack_require__(1415);
	
	var _Year2 = _interopRequireDefault(_Year);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Years = function (_PureComponent) {
	  _inherits(Years, _PureComponent);
	
	  function Years() {
	    _classCallCheck(this, Years);
	
	    return _possibleConstructorReturn(this, (Years.__proto__ || Object.getPrototypeOf(Years)).apply(this, arguments));
	  }
	
	  _createClass(Years, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          otherProps = _objectWithoutProperties(_props, ['activeStartDate']);
	
	      return _react2.default.createElement(_TileGroup2.default, _extends({}, otherProps, {
	        className: 'react-calendar__decade-view__years',
	        dateTransform: function dateTransform(year) {
	          return new Date(year, 0, 1);
	        },
	        dateType: 'year',
	        end: this.end,
	        start: this.start,
	        tile: _Year2.default
	      }));
	    }
	  }, {
	    key: 'start',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getBeginOfDecadeYear)(activeStartDate);
	    }
	  }, {
	    key: 'end',
	    get: function get() {
	      return this.start + 9;
	    }
	  }]);
	
	  return Years;
	}(_react.PureComponent);
	
	exports.default = Years;
	
	
	Years.propTypes = _extends({}, _propTypes.tileGroupProps);

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var toPercent = function toPercent(num) {
	  return num + '%';
	};
	
	var Flex = function Flex(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      direction = _ref.direction,
	      count = _ref.count,
	      offset = _ref.offset,
	      style = _ref.style,
	      wrap = _ref.wrap,
	      otherProps = _objectWithoutProperties(_ref, ['children', 'className', 'direction', 'count', 'offset', 'style', 'wrap']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      className: className,
	      style: _extends({
	        display: 'flex',
	        flexDirection: direction,
	        flexWrap: wrap ? 'wrap' : 'no-wrap'
	      }, style)
	    }, otherProps),
	    _react2.default.Children.map(children, function (child, index) {
	      return _react2.default.cloneElement(child, _extends({}, child.props, {
	        style: {
	          flexBasis: toPercent(100 / count),
	          maxWidth: toPercent(100 / count),
	          overflow: 'hidden',
	          marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
	        }
	      }));
	    })
	  );
	};
	
	Flex.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  count: _propTypes2.default.number.isRequired,
	  direction: _propTypes2.default.string,
	  offset: _propTypes2.default.number,
	  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	  wrap: _propTypes2.default.bool
	};
	
	exports.default = Flex;

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Days = __webpack_require__(1418);
	
	var _Days2 = _interopRequireDefault(_Days);
	
	var _Weekdays = __webpack_require__(1421);
	
	var _Weekdays2 = _interopRequireDefault(_Weekdays);
	
	var _WeekNumbers = __webpack_require__(1420);
	
	var _WeekNumbers2 = _interopRequireDefault(_WeekNumbers);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MonthView = function (_PureComponent) {
	  _inherits(MonthView, _PureComponent);
	
	  function MonthView() {
	    _classCallCheck(this, MonthView);
	
	    return _possibleConstructorReturn(this, (MonthView.__proto__ || Object.getPrototypeOf(MonthView)).apply(this, arguments));
	  }
	
	  _createClass(MonthView, [{
	    key: 'renderWeekdays',
	    value: function renderWeekdays() {
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          formatShortWeekday = _props.formatShortWeekday,
	          locale = _props.locale;
	
	
	      return _react2.default.createElement(_Weekdays2.default, {
	        calendarType: this.calendarType,
	        locale: locale,
	        month: activeStartDate,
	        formatShortWeekday: formatShortWeekday
	      });
	    }
	  }, {
	    key: 'renderWeekNumbers',
	    value: function renderWeekNumbers() {
	      var showWeekNumbers = this.props.showWeekNumbers;
	
	
	      if (!showWeekNumbers) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          activeStartDate = _props2.activeStartDate,
	          onClickWeekNumber = _props2.onClickWeekNumber,
	          showFixedNumberOfWeeks = _props2.showFixedNumberOfWeeks;
	
	
	      return _react2.default.createElement(_WeekNumbers2.default, {
	        activeStartDate: activeStartDate,
	        calendarType: this.calendarType,
	        onClickWeekNumber: onClickWeekNumber,
	        showFixedNumberOfWeeks: showFixedNumberOfWeeks
	      });
	    }
	  }, {
	    key: 'renderDays',
	    value: function renderDays() {
	      var _props3 = this.props,
	          calendarType = _props3.calendarType,
	          showWeekNumbers = _props3.showWeekNumbers,
	          childProps = _objectWithoutProperties(_props3, ['calendarType', 'showWeekNumbers']);
	
	      return _react2.default.createElement(_Days2.default, _extends({
	        calendarType: this.calendarType
	      }, childProps));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var showWeekNumbers = this.props.showWeekNumbers;
	
	
	      var className = 'react-calendar__month-view';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: [className, showWeekNumbers ? className + '--weekNumbers' : ''].join(' ')
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              alignItems: 'flex-end'
	            }
	          },
	          this.renderWeekNumbers(),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                flexGrow: 1,
	                width: '100%'
	              }
	            },
	            this.renderWeekdays(),
	            this.renderDays()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'calendarType',
	    get: function get() {
	      var _props4 = this.props,
	          calendarType = _props4.calendarType,
	          locale = _props4.locale;
	
	
	      if (calendarType) {
	        return calendarType;
	      }
	
	      switch (locale) {
	        case 'en-CA':
	        case 'en-US':
	        case 'es-AR':
	        case 'es-BO':
	        case 'es-CL':
	        case 'es-CO':
	        case 'es-CR':
	        case 'es-DO':
	        case 'es-EC':
	        case 'es-GT':
	        case 'es-HN':
	        case 'es-MX':
	        case 'es-NI':
	        case 'es-PA':
	        case 'es-PE':
	        case 'es-PR':
	        case 'es-SV':
	        case 'es-VE':
	        case 'pt-BR':
	          return 'US';
	        // ar-LB, ar-MA intentionally missing
	        case 'ar':
	        case 'ar-AE':
	        case 'ar-BH':
	        case 'ar-DZ':
	        case 'ar-EG':
	        case 'ar-IQ':
	        case 'ar-JO':
	        case 'ar-KW':
	        case 'ar-LY':
	        case 'ar-OM':
	        case 'ar-QA':
	        case 'ar-SA':
	        case 'ar-SD':
	        case 'ar-SY':
	        case 'ar-YE':
	        case 'dv':
	        case 'dv-MV':
	        case 'ps':
	        case 'ps-AR':
	          return 'Arabic';
	        case 'he':
	        case 'he-IL':
	          return 'Hebrew';
	        default:
	          return 'ISO 8601';
	      }
	    }
	  }]);
	
	  return MonthView;
	}(_react.PureComponent);
	
	exports.default = MonthView;
	
	
	MonthView.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarType: _propTypes3.isCalendarType,
	  formatShortWeekday: _propTypes2.default.func,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes3.isMaxDate,
	  minDate: _propTypes3.isMinDate,
	  onChange: _propTypes2.default.func,
	  onClickWeekNumber: _propTypes2.default.func,
	  setActiveRange: _propTypes2.default.func,
	  showFixedNumberOfWeeks: _propTypes2.default.bool,
	  showNeighboringMonth: _propTypes2.default.bool,
	  showWeekNumbers: _propTypes2.default.bool,
	  value: _propTypes3.isValue,
	  valueType: _propTypes2.default.string
	};

/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tile = __webpack_require__(111);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var className = 'react-calendar__month-view__days__day';
	
	var Day = function Day(_ref) {
	  var calendarType = _ref.calendarType,
	      classes = _ref.classes,
	      currentMonthIndex = _ref.currentMonthIndex,
	      date = _ref.date,
	      otherProps = _objectWithoutProperties(_ref, ['calendarType', 'classes', 'currentMonthIndex', 'date']);
	
	  return _react2.default.createElement(
	    _Tile2.default,
	    _extends({}, otherProps, {
	      classes: [].concat(_toConsumableArray(classes), [className, (0, _dates.isWeekend)(date, calendarType) ? className + '--weekend' : null, date.getMonth() !== currentMonthIndex ? className + '--neighboringMonth' : null]),
	      date: date,
	      dateTime: (0, _dates.getISOLocalDate)(date) + 'T00:00:00.000',
	      maxDateTransform: _dates.getEndOfDay,
	      minDateTransform: _dates.getBeginOfDay,
	      view: 'month'
	    }),
	    (0, _dates.getDay)(date)
	  );
	};
	
	Day.propTypes = _extends({
	  currentMonthIndex: _propTypes2.default.number.isRequired
	}, _propTypes3.tileProps);
	
	exports.default = Day;

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TileGroup = __webpack_require__(112);
	
	var _TileGroup2 = _interopRequireDefault(_TileGroup);
	
	var _Day = __webpack_require__(1417);
	
	var _Day2 = _interopRequireDefault(_Day);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Days = function (_PureComponent) {
	  _inherits(Days, _PureComponent);
	
	  function Days() {
	    _classCallCheck(this, Days);
	
	    return _possibleConstructorReturn(this, (Days.__proto__ || Object.getPrototypeOf(Days)).apply(this, arguments));
	  }
	
	  _createClass(Days, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var monthIndex = this.monthIndex;
	
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          showNeighboringMonth = _props.showNeighboringMonth,
	          otherProps = _objectWithoutProperties(_props, ['activeStartDate', 'showNeighboringMonth']);
	
	      return _react2.default.createElement(_TileGroup2.default, _extends({}, otherProps, {
	        className: 'react-calendar__month-view__days',
	        count: 7,
	        dateTransform: function dateTransform(day) {
	          return new Date(_this2.year, monthIndex, day);
	        },
	        dateType: 'day',
	        end: this.end,
	        offset: this.offset,
	        start: this.start,
	        tile: _Day2.default
	        // Tile props
	        , currentMonthIndex: monthIndex
	      }));
	    }
	  }, {
	    key: 'offset',
	    get: function get() {
	      var _props2 = this.props,
	          showFixedNumberOfWeeks = _props2.showFixedNumberOfWeeks,
	          showNeighboringMonth = _props2.showNeighboringMonth;
	
	
	      if (showFixedNumberOfWeeks || showNeighboringMonth) {
	        return 0;
	      }
	
	      var _props3 = this.props,
	          activeStartDate = _props3.activeStartDate,
	          calendarType = _props3.calendarType;
	
	
	      return (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
	    }
	
	    /**
	     * Defines on which day of the month the grid shall start. If we simply show current
	     * month, we obviously start on day one, but if showNeighboringMonth is set to
	     * true, we need to find the beginning of the week the first day of the month is in.
	     */
	
	  }, {
	    key: 'start',
	    get: function get() {
	      var _props4 = this.props,
	          showFixedNumberOfWeeks = _props4.showFixedNumberOfWeeks,
	          showNeighboringMonth = _props4.showNeighboringMonth;
	
	
	      if (showFixedNumberOfWeeks || showNeighboringMonth) {
	        var _props5 = this.props,
	            activeStartDate = _props5.activeStartDate,
	            calendarType = _props5.calendarType;
	
	        return -(0, _dates.getDayOfWeek)(activeStartDate, calendarType) + 1;
	      }
	
	      return 1;
	    }
	
	    /**
	     * Defines on which day of the month the grid shall end. If we simply show current
	     * month, we need to stop on the last day of the month, but if showNeighboringMonth
	     * is set to true, we need to find the end of the week the last day of the month is in.
	     */
	
	  }, {
	    key: 'end',
	    get: function get() {
	      var _props6 = this.props,
	          activeStartDate = _props6.activeStartDate,
	          showFixedNumberOfWeeks = _props6.showFixedNumberOfWeeks,
	          showNeighboringMonth = _props6.showNeighboringMonth;
	
	      var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);
	
	      if (showFixedNumberOfWeeks) {
	        // Always show 6 weeks
	        return this.start + 6 * 7 - 1;
	      }
	
	      if (showNeighboringMonth) {
	        var year = this.year,
	            monthIndex = this.monthIndex;
	        var calendarType = this.props.calendarType;
	
	        var activeEndDate = new Date(year, monthIndex, daysInMonth);
	        return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
	      }
	
	      return daysInMonth;
	    }
	  }, {
	    key: 'year',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getYear)(activeStartDate);
	    }
	  }, {
	    key: 'monthIndex',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getMonthIndex)(activeStartDate);
	    }
	  }]);
	
	  return Days;
	}(_react.PureComponent);
	
	exports.default = Days;
	
	
	Days.propTypes = _extends({
	  calendarType: _propTypes3.isCalendarType.isRequired,
	  showFixedNumberOfWeeks: _propTypes2.default.bool,
	  showNeighboringMonth: _propTypes2.default.bool
	}, _propTypes3.tileGroupProps);

/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WeekNumber = function WeekNumber(_ref) {
	  var date = _ref.date,
	      onClickWeekNumber = _ref.onClickWeekNumber,
	      weekNumber = _ref.weekNumber;
	  return onClickWeekNumber ? _react2.default.createElement(
	    'button',
	    {
	      className: 'react-calendar__tile',
	      onClick: function onClick() {
	        return onClickWeekNumber(weekNumber, date);
	      },
	      style: { flexGrow: 1 },
	      type: 'button'
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      weekNumber
	    )
	  ) : _react2.default.createElement(
	    'div',
	    {
	      className: 'react-calendar__tile',
	      style: { flexGrow: 1 }
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      weekNumber
	    )
	  );
	};
	
	WeekNumber.propTypes = {
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  onClickWeekNumber: _propTypes2.default.func,
	  weekNumber: _propTypes2.default.number.isRequired
	};
	
	exports.default = WeekNumber;

/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _WeekNumber = __webpack_require__(1419);
	
	var _WeekNumber2 = _interopRequireDefault(_WeekNumber);
	
	var _Flex = __webpack_require__(168);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WeekNumbers = function (_PureComponent) {
	  _inherits(WeekNumbers, _PureComponent);
	
	  function WeekNumbers() {
	    _classCallCheck(this, WeekNumbers);
	
	    return _possibleConstructorReturn(this, (WeekNumbers.__proto__ || Object.getPrototypeOf(WeekNumbers)).apply(this, arguments));
	  }
	
	  _createClass(WeekNumbers, [{
	    key: 'render',
	    value: function render() {
	      var dates = this.dates,
	          numberOfWeeks = this.numberOfWeeks,
	          weekNumbers = this.weekNumbers;
	      var onClickWeekNumber = this.props.onClickWeekNumber;
	
	
	      return _react2.default.createElement(
	        _Flex2.default,
	        {
	          className: 'react-calendar__month-view__weekNumbers',
	          count: numberOfWeeks,
	          direction: 'column',
	          style: { flexBasis: 'calc(100% * (1 / 8)', flexShrink: 0 }
	        },
	        weekNumbers.map(function (weekNumber, weekIndex) {
	          return _react2.default.createElement(_WeekNumber2.default, {
	            date: dates[weekIndex],
	            key: weekNumber,
	            onClickWeekNumber: onClickWeekNumber,
	            weekNumber: weekNumber
	          });
	        })
	      );
	    }
	  }, {
	    key: 'startWeekday',
	    get: function get() {
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          calendarType = _props.calendarType;
	
	      return (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
	    }
	  }, {
	    key: 'numberOfDays',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getDaysInMonth)(activeStartDate);
	    }
	  }, {
	    key: 'numberOfWeeks',
	    get: function get() {
	      var showFixedNumberOfWeeks = this.props.showFixedNumberOfWeeks;
	
	
	      if (showFixedNumberOfWeeks) {
	        return 6;
	      }
	
	      var days = this.numberOfDays - (7 - this.startWeekday);
	      return 1 + Math.ceil(days / 7);
	    }
	  }, {
	    key: 'year',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getYear)(activeStartDate);
	    }
	  }, {
	    key: 'monthIndex',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getMonthIndex)(activeStartDate);
	    }
	  }, {
	    key: 'day',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getDay)(activeStartDate);
	    }
	  }, {
	    key: 'dates',
	    get: function get() {
	      var year = this.year,
	          monthIndex = this.monthIndex,
	          numberOfWeeks = this.numberOfWeeks,
	          day = this.day;
	      var calendarType = this.props.calendarType;
	
	
	      var dates = [];
	      for (var index = 0; index < numberOfWeeks; index += 1) {
	        dates.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
	      }
	      return dates;
	    }
	  }, {
	    key: 'weekNumbers',
	    get: function get() {
	      var dates = this.dates;
	      var calendarType = this.props.calendarType;
	
	      return dates.map(function (date) {
	        return (0, _dates.getWeekNumber)(date, calendarType);
	      });
	    }
	  }]);
	
	  return WeekNumbers;
	}(_react.PureComponent);
	
	exports.default = WeekNumbers;
	
	
	WeekNumbers.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  calendarType: _propTypes3.isCalendarType.isRequired,
	  onClickWeekNumber: _propTypes2.default.func,
	  showFixedNumberOfWeeks: _propTypes2.default.bool
	};

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Flex = __webpack_require__(168);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _dates = __webpack_require__(24);
	
	var _dateFormatter = __webpack_require__(169);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Weekdays = function (_Component) {
	  _inherits(Weekdays, _Component);
	
	  function Weekdays() {
	    _classCallCheck(this, Weekdays);
	
	    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
	  }
	
	  _createClass(Weekdays, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var _props = this.props,
	          calendarType = _props.calendarType,
	          locale = _props.locale;
	
	
	      return nextProps.calendarType !== calendarType || nextProps.locale !== locale;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          calendarType = _props2.calendarType,
	          formatShortWeekday = _props2.formatShortWeekday,
	          locale = _props2.locale;
	      var beginOfMonth = this.beginOfMonth,
	          year = this.year,
	          monthIndex = this.monthIndex;
	
	
	      var weekdays = [];
	
	      for (var weekday = 1; weekday <= 7; weekday += 1) {
	        var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
	
	        weekdays.push(_react2.default.createElement(
	          'div',
	          {
	            className: 'react-calendar__month-view__weekdays__weekday',
	            key: weekday,
	            style: { flexGrow: 1 }
	          },
	          formatShortWeekday(weekdayDate, locale).replace('.', '')
	        ));
	      }
	
	      return _react2.default.createElement(
	        _Flex2.default,
	        {
	          className: 'react-calendar__month-view__weekdays',
	          count: 7
	        },
	        weekdays
	      );
	    }
	  }, {
	    key: 'beginOfMonth',
	    get: function get() {
	      var month = this.props.month;
	
	
	      return (0, _dates.getBeginOfMonth)(month);
	    }
	  }, {
	    key: 'year',
	    get: function get() {
	      var beginOfMonth = this.beginOfMonth;
	
	
	      return (0, _dates.getYear)(beginOfMonth);
	    }
	  }, {
	    key: 'monthIndex',
	    get: function get() {
	      var beginOfMonth = this.beginOfMonth;
	
	
	      return (0, _dates.getMonthIndex)(beginOfMonth);
	    }
	  }]);
	
	  return Weekdays;
	}(_react.Component);
	
	exports.default = Weekdays;
	
	
	Weekdays.defaultProps = {
	  formatShortWeekday: _dateFormatter.formatShortWeekday
	};
	
	Weekdays.propTypes = {
	  calendarType: _propTypes3.isCalendarType.isRequired,
	  formatShortWeekday: _propTypes2.default.func,
	  locale: _propTypes2.default.string,
	  month: _propTypes2.default.oneOfType([_propTypes2.default.string, // Only strings that are parseable to integer
	  _propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired
	};

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mergeClassNames = __webpack_require__(258);
	
	var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tile = function Tile(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      date = _ref.date,
	      dateTime = _ref.dateTime,
	      maxDate = _ref.maxDate,
	      maxDateTransform = _ref.maxDateTransform,
	      minDate = _ref.minDate,
	      minDateTransform = _ref.minDateTransform,
	      onClick = _ref.onClick,
	      onMouseOver = _ref.onMouseOver,
	      style = _ref.style,
	      tileClassName = _ref.tileClassName,
	      tileContent = _ref.tileContent,
	      tileDisabled = _ref.tileDisabled,
	      view = _ref.view;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: (0, _mergeClassNames2.default)(classes, tileClassName instanceof Function ? tileClassName({ date: date, view: view }) : tileClassName),
	      disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({ date: date, view: view }),
	      onClick: onClick && function () {
	        return onClick(date);
	      },
	      onMouseOver: onMouseOver && function () {
	        return onMouseOver(date);
	      },
	      onFocus: onMouseOver && function () {
	        return onMouseOver(date);
	      },
	      style: style,
	      type: 'button'
	    },
	    _react2.default.createElement(
	      'time',
	      { dateTime: dateTime },
	      children
	    ),
	    typeof tileContent === 'function' ? tileContent({ date: date, view: view }) : tileContent
	  );
	};
	
	Tile.propTypes = _extends({}, _propTypes3.tileProps, {
	  children: _propTypes2.default.node.isRequired,
	  dateTime: _propTypes2.default.string.isRequired,
	  maxDateTransform: _propTypes2.default.func.isRequired,
	  minDateTransform: _propTypes2.default.func.isRequired
	});
	
	exports.default = Tile;

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Flex = __webpack_require__(168);
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _utils = __webpack_require__(266);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TileGroup = function TileGroup(_ref) {
	  var className = _ref.className,
	      count = _ref.count,
	      dateTransform = _ref.dateTransform,
	      dateType = _ref.dateType,
	      end = _ref.end,
	      hover = _ref.hover,
	      offset = _ref.offset,
	      start = _ref.start,
	      step = _ref.step,
	      Tile = _ref.tile,
	      value = _ref.value,
	      valueType = _ref.valueType,
	      tileProps = _objectWithoutProperties(_ref, ['className', 'count', 'dateTransform', 'dateType', 'end', 'hover', 'offset', 'start', 'step', 'tile', 'value', 'valueType']);
	
	  var tiles = [];
	  for (var point = start; point <= end; point += step) {
	    var date = dateTransform(point);
	
	    tiles.push(_react2.default.createElement(Tile, _extends({
	      classes: (0, _utils.getTileClasses)({
	        value: value, valueType: valueType, date: date, dateType: dateType, hover: hover
	      }),
	      date: date,
	      point: point,
	      key: date.getTime()
	    }, tileProps)));
	  }
	
	  return _react2.default.createElement(
	    _Flex2.default,
	    {
	      className: className,
	      count: count,
	      offset: offset,
	      wrap: true
	    },
	    tiles
	  );
	};
	
	TileGroup.propTypes = _extends({}, _propTypes3.tileGroupProps, {
	  activeStartDate: _propTypes2.default.instanceOf(Date),
	  count: _propTypes2.default.number,
	  dateTransform: _propTypes2.default.func.isRequired,
	  offset: _propTypes2.default.number,
	  tile: _propTypes2.default.func.isRequired,
	  step: _propTypes2.default.number
	});
	
	TileGroup.defaultProps = {
	  count: 3,
	  step: 1
	};
	
	exports.default = TileGroup;

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Months = __webpack_require__(1423);
	
	var _Months2 = _interopRequireDefault(_Months);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YearView = function (_PureComponent) {
	  _inherits(YearView, _PureComponent);
	
	  function YearView() {
	    _classCallCheck(this, YearView);
	
	    return _possibleConstructorReturn(this, (YearView.__proto__ || Object.getPrototypeOf(YearView)).apply(this, arguments));
	  }
	
	  _createClass(YearView, [{
	    key: 'renderMonths',
	    value: function renderMonths() {
	      return _react2.default.createElement(_Months2.default, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'react-calendar__year-view' },
	        this.renderMonths()
	      );
	    }
	  }]);
	
	  return YearView;
	}(_react.PureComponent);
	
	exports.default = YearView;
	
	
	YearView.propTypes = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  formatMonth: _propTypes2.default.func,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes3.isMaxDate,
	  minDate: _propTypes3.isMinDate,
	  onChange: _propTypes2.default.func,
	  setActiveRange: _propTypes2.default.func,
	  value: _propTypes3.isValue,
	  valueType: _propTypes2.default.string
	};

/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tile = __webpack_require__(111);
	
	var _Tile2 = _interopRequireDefault(_Tile);
	
	var _dates = __webpack_require__(24);
	
	var _dateFormatter = __webpack_require__(169);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var className = 'react-calendar__year-view__months__month';
	
	var Month = function Month(_ref) {
	  var classes = _ref.classes,
	      date = _ref.date,
	      formatMonth = _ref.formatMonth,
	      locale = _ref.locale,
	      otherProps = _objectWithoutProperties(_ref, ['classes', 'date', 'formatMonth', 'locale']);
	
	  return _react2.default.createElement(
	    _Tile2.default,
	    _extends({}, otherProps, {
	      classes: [].concat(_toConsumableArray(classes), [className]),
	      date: date,
	      dateTime: (0, _dates.getISOLocalMonth)(date) + 'T00:00:00.000',
	      maxDateTransform: _dates.getEndOfMonth,
	      minDateTransform: _dates.getBeginOfMonth,
	      view: 'year'
	    }),
	    formatMonth(date, locale)
	  );
	};
	
	Month.defaultProps = {
	  formatMonth: _dateFormatter.formatMonth
	};
	
	Month.propTypes = _extends({}, _propTypes3.tileProps, {
	  formatMonth: _propTypes2.default.func,
	  locale: _propTypes2.default.string
	});
	
	exports.default = Month;

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TileGroup = __webpack_require__(112);
	
	var _TileGroup2 = _interopRequireDefault(_TileGroup);
	
	var _Month = __webpack_require__(1422);
	
	var _Month2 = _interopRequireDefault(_Month);
	
	var _dates = __webpack_require__(24);
	
	var _propTypes3 = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Months = function (_PureComponent) {
	  _inherits(Months, _PureComponent);
	
	  function Months() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Months);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Months.__proto__ || Object.getPrototypeOf(Months)).call.apply(_ref, [this].concat(args))), _this), _this.start = 0, _this.end = 11, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Months, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeStartDate = _props.activeStartDate,
	          otherProps = _objectWithoutProperties(_props, ['activeStartDate']);
	
	      return _react2.default.createElement(_TileGroup2.default, _extends({}, otherProps, {
	        className: 'react-calendar__year-view__months',
	        dateTransform: function dateTransform(monthIndex) {
	          return new Date(_this2.year, monthIndex, 1);
	        },
	        dateType: 'month',
	        end: this.end,
	        start: this.start,
	        tile: _Month2.default
	      }));
	    }
	  }, {
	    key: 'year',
	    get: function get() {
	      var activeStartDate = this.props.activeStartDate;
	
	      return (0, _dates.getYear)(activeStartDate);
	    }
	  }]);
	
	  return Months;
	}(_react.PureComponent);
	
	exports.default = Months;
	
	
	Months.propTypes = _extends({}, _propTypes3.tileGroupProps, {
	  locale: _propTypes2.default.string
	});

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MonthView = exports.YearView = exports.DecadeView = exports.CenturyView = exports.Calendar = undefined;
	
	var _Calendar = __webpack_require__(1411);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _CenturyView = __webpack_require__(262);
	
	var _CenturyView2 = _interopRequireDefault(_CenturyView);
	
	var _DecadeView = __webpack_require__(263);
	
	var _DecadeView2 = _interopRequireDefault(_DecadeView);
	
	var _YearView = __webpack_require__(265);
	
	var _YearView2 = _interopRequireDefault(_YearView);
	
	var _MonthView = __webpack_require__(264);
	
	var _MonthView2 = _interopRequireDefault(_MonthView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Calendar2.default;
	exports.Calendar = _Calendar2.default;
	exports.CenturyView = _CenturyView2.default;
	exports.DecadeView = _DecadeView2.default;
	exports.YearView = _YearView2.default;
	exports.MonthView = _MonthView2.default;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatShortWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatDate = undefined;
	
	var _getUserLocale = __webpack_require__(887);
	
	var _getUserLocale2 = _interopRequireDefault(_getUserLocale);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatterCache = {};
	
	/**
	 * Gets Intl-based date formatter from formatter cache. If it doesn't exist in cache
	 * just yet, it will be created on the fly.
	 */
	var getFormatter = function getFormatter(options, locale) {
	  if (!locale) {
	    // Default parameter is not enough as it does not protect us from null values
	    // eslint-disable-next-line no-param-reassign
	    locale = (0, _getUserLocale2.default)();
	  }
	
	  var stringifiedOptions = JSON.stringify(options);
	
	  if (!formatterCache[locale]) {
	    formatterCache[locale] = {};
	  }
	
	  if (!formatterCache[locale][stringifiedOptions]) {
	    formatterCache[locale][stringifiedOptions] = new Intl.DateTimeFormat(locale, options).format;
	  }
	
	  return formatterCache[locale][stringifiedOptions];
	};
	
	/**
	 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
	 * Workaround for bug in WebKit and Firefox with historical dates.
	 * For more details, see:
	 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
	 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
	 *
	 * @param {Date} date Date.
	 */
	var toSafeHour = function toSafeHour(date) {
	  var safeDate = new Date(date);
	  return new Date(safeDate.setHours(12));
	};
	
	var formatDate = exports.formatDate = function formatDate(date, locale) {
	  return getFormatter({ day: 'numeric', month: 'numeric', year: 'numeric' }, locale)(toSafeHour(date));
	};
	
	var formatMonthYear = exports.formatMonthYear = function formatMonthYear(date, locale) {
	  return getFormatter({ month: 'long', year: 'numeric' }, locale)(toSafeHour(date));
	};
	
	var formatMonth = exports.formatMonth = function formatMonth(date, locale) {
	  return getFormatter({ month: 'long' }, locale)(toSafeHour(date));
	};
	
	var formatShortWeekday = exports.formatShortWeekday = function formatShortWeekday(date, locale) {
	  return getFormatter({ weekday: 'short' }, locale)(toSafeHour(date));
	};

/***/ }),

/***/ 24:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _map = [].concat(_toConsumableArray(Array(7))).map(function (el, index) {
	  return index;
	}),
	    _map2 = _slicedToArray(_map, 7),
	
	// eslint-disable-next-line no-unused-vars
	SUNDAY = _map2[0],
	    MONDAY = _map2[1],
	    TUESDAY = _map2[2],
	    WEDNESDAY = _map2[3],
	    THURSDAY = _map2[4],
	    FRIDAY = _map2[5],
	    SATURDAY = _map2[6];
	
	/* Simple getters - getting a property of a given point in time */
	
	var getYear = exports.getYear = function getYear(date) {
	  if (date instanceof Date) {
	    return date.getFullYear();
	  }
	
	  if (typeof date === 'number') {
	    return date;
	  }
	
	  var year = parseInt(date, 10);
	
	  if (typeof date === 'string' && !isNaN(year)) {
	    return year;
	  }
	
	  throw new Error('Failed to get year from date: ' + date + '.');
	};
	
	var getMonth = exports.getMonth = function getMonth(date) {
	  return date.getMonth() + 1;
	};
	
	var getMonthIndex = exports.getMonthIndex = function getMonthIndex(date) {
	  return date.getMonth();
	};
	
	var getDay = exports.getDay = function getDay(date) {
	  return date.getDate();
	};
	
	var getDayOfWeek = exports.getDayOfWeek = function getDayOfWeek(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	
	  var weekday = date.getDay();
	
	  switch (calendarType) {
	    case 'ISO 8601':
	      // Shifts days of the week so that Monday is 0, Sunday is 6
	      return (weekday + 6) % 7;
	    case 'Arabic':
	      return (weekday + 1) % 7;
	    case 'Hebrew':
	    case 'US':
	      return weekday;
	    default:
	      throw new Error('Unsupported calendar type.');
	  }
	};
	
	/* Complex getters - getting a property somehow related to a given point in time */
	
	var getBeginOfCenturyYear = exports.getBeginOfCenturyYear = function getBeginOfCenturyYear(date) {
	  var year = getYear(date) - 1;
	  return year + -year % 100 + 1;
	};
	
	var getBeginOfCentury = exports.getBeginOfCentury = function getBeginOfCentury(date) {
	  var beginOfCenturyYear = getBeginOfCenturyYear(date);
	  return new Date(beginOfCenturyYear, 0, 1);
	};
	
	var getEndOfCentury = exports.getEndOfCentury = function getEndOfCentury(date) {
	  var beginOfCenturyYear = getBeginOfCenturyYear(date);
	  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
	};
	
	var getCenturyRange = exports.getCenturyRange = function getCenturyRange(date) {
	  return [getBeginOfCentury(date), getEndOfCentury(date)];
	};
	
	var getBeginOfPreviousCentury = exports.getBeginOfPreviousCentury = function getBeginOfPreviousCentury(date) {
	  var previousCenturyYear = getYear(date) - 100;
	  return getBeginOfCentury(previousCenturyYear);
	};
	
	var getEndOfPreviousCentury = exports.getEndOfPreviousCentury = function getEndOfPreviousCentury(date) {
	  var previousCenturyYear = getYear(date) - 100;
	  return getEndOfCentury(previousCenturyYear);
	};
	
	var getBeginOfNextCentury = exports.getBeginOfNextCentury = function getBeginOfNextCentury(date) {
	  var nextCenturyYear = getYear(date) + 100;
	  return getBeginOfCentury(nextCenturyYear);
	};
	
	var getBeginOfDecadeYear = exports.getBeginOfDecadeYear = function getBeginOfDecadeYear(date) {
	  var year = getYear(date) - 1;
	  return year + -year % 10 + 1;
	};
	
	var getBeginOfDecade = exports.getBeginOfDecade = function getBeginOfDecade(date) {
	  var beginOfDecadeYear = getBeginOfDecadeYear(date);
	  return new Date(beginOfDecadeYear, 0, 1);
	};
	
	var getEndOfDecade = exports.getEndOfDecade = function getEndOfDecade(date) {
	  var beginOfDecadeYear = getBeginOfDecadeYear(date);
	  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
	};
	
	var getDecadeRange = exports.getDecadeRange = function getDecadeRange(date) {
	  return [getBeginOfDecade(date), getEndOfDecade(date)];
	};
	
	var getBeginOfPreviousDecade = exports.getBeginOfPreviousDecade = function getBeginOfPreviousDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
	  return getBeginOfDecade(previousDecadeYear);
	};
	
	var getEndOfPreviousDecade = exports.getEndOfPreviousDecade = function getEndOfPreviousDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
	  return getEndOfDecade(previousDecadeYear);
	};
	
	var getBeginOfNextDecade = exports.getBeginOfNextDecade = function getBeginOfNextDecade(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
	  return getBeginOfDecade(nextDecadeYear);
	};
	
	/**
	 * Returns the beginning of a given year.
	 *
	 * @param {Date} date Date.
	 */
	var getBeginOfYear = exports.getBeginOfYear = function getBeginOfYear(date) {
	  var year = getYear(date);
	  return new Date(year, 0, 1);
	};
	
	/**
	 * Returns the end of a given year.
	 *
	 * @param {Date} date Date.
	 */
	var getEndOfYear = exports.getEndOfYear = function getEndOfYear(date) {
	  var year = getYear(date);
	  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
	};
	
	/**
	 * Returns an array with the beginning and the end of a given year.
	 *
	 * @param {Date} date Date.
	 */
	var getYearRange = exports.getYearRange = function getYearRange(date) {
	  return [getBeginOfYear(date), getEndOfYear(date)];
	};
	
	var getBeginOfPreviousYear = exports.getBeginOfPreviousYear = function getBeginOfPreviousYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var previousYear = getYear(date) - offset;
	  return getBeginOfYear(previousYear);
	};
	
	var getEndOfPreviousYear = exports.getEndOfPreviousYear = function getEndOfPreviousYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var previousYear = getYear(date) - offset;
	  return getEndOfYear(previousYear);
	};
	
	var getBeginOfNextYear = exports.getBeginOfNextYear = function getBeginOfNextYear(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var nextYear = getYear(date) + offset;
	  return getBeginOfYear(nextYear);
	};
	
	/**
	 * Returns the beginning of a given month.
	 *
	 * @param {Date} date Date.
	 */
	var getBeginOfMonth = exports.getBeginOfMonth = function getBeginOfMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex, 1);
	};
	
	/**
	 * Returns the end of a given month.
	 *
	 * @param {Date} date Date.
	 */
	var getEndOfMonth = exports.getEndOfMonth = function getEndOfMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
	};
	
	/**
	 * Returns the beginning of a given week.
	 *
	 * @param {Date} date Date.
	 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
	 */
	var getBeginOfWeek = exports.getBeginOfWeek = function getBeginOfWeek(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = date.getDate() - getDayOfWeek(date, calendarType);
	  return new Date(year, monthIndex, day);
	};
	
	/**
	 * Returns an array with the beginning and the end of a given month.
	 *
	 * @param {Date} date Date.
	 */
	var getMonthRange = exports.getMonthRange = function getMonthRange(date) {
	  return [getBeginOfMonth(date), getEndOfMonth(date)];
	};
	
	var getDifferentMonth = function getDifferentMonth(date, offset) {
	  var year = getYear(date);
	  var previousMonthIndex = getMonthIndex(date) + offset;
	  return new Date(year, previousMonthIndex, 1);
	};
	
	var getBeginOfPreviousMonth = exports.getBeginOfPreviousMonth = function getBeginOfPreviousMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var previousMonth = getDifferentMonth(date, -offset);
	  return getBeginOfMonth(previousMonth);
	};
	
	var getEndOfPreviousMonth = exports.getEndOfPreviousMonth = function getEndOfPreviousMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var previousMonth = getDifferentMonth(date, -offset);
	  return getEndOfMonth(previousMonth);
	};
	
	var getBeginOfNextMonth = exports.getBeginOfNextMonth = function getBeginOfNextMonth(date) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  var nextMonth = getDifferentMonth(date, offset);
	  return getBeginOfMonth(nextMonth);
	};
	
	var getBeginOfDay = exports.getBeginOfDay = function getBeginOfDay(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = getDay(date);
	  return new Date(year, monthIndex, day);
	};
	
	var getEndOfDay = exports.getEndOfDay = function getEndOfDay(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  var day = getDay(date);
	  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
	};
	
	/**
	 * Returns an array with the beginning and the end of a given day.
	 *
	 * @param {Date} date Date.
	 */
	var getDayRange = exports.getDayRange = function getDayRange(date) {
	  return [getBeginOfDay(date), getEndOfDay(date)];
	};
	
	/**
	 * Gets week number according to ISO 8601 or US standard.
	 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
	 * In US calendar week 1 is the one with January 1.
	 *
	 * @param {Date} date Date.
	 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
	 */
	var getWeekNumber = exports.getWeekNumber = function getWeekNumber(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	
	  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
	  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
	  var year = getYear(date) + 1;
	  var dayInWeekOne = void 0;
	  var beginOfFirstWeek = void 0;
	
	  // Look for the first week one that does not come after a given date
	  do {
	    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
	    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
	    year -= 1;
	  } while (date - beginOfFirstWeek < 0);
	
	  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
	};
	
	/**
	 * Returns the beginning of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	var getBegin = exports.getBegin = function getBegin(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfCentury(date);
	    case 'decade':
	      return getBeginOfDecade(date);
	    case 'year':
	      return getBeginOfYear(date);
	    case 'month':
	      return getBeginOfMonth(date);
	    case 'day':
	      return getBeginOfDay(date);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	var getBeginPrevious = exports.getBeginPrevious = function getBeginPrevious(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfPreviousCentury(date);
	    case 'decade':
	      return getBeginOfPreviousDecade(date);
	    case 'year':
	      return getBeginOfPreviousYear(date);
	    case 'month':
	      return getBeginOfPreviousMonth(date);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	var getBeginNext = exports.getBeginNext = function getBeginNext(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getBeginOfNextCentury(date);
	    case 'decade':
	      return getBeginOfNextDecade(date);
	    case 'year':
	      return getBeginOfNextYear(date);
	    case 'month':
	      return getBeginOfNextMonth(date);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	var getBeginPrevious2 = exports.getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getBeginOfPreviousDecade(date, 100);
	    case 'year':
	      return getBeginOfPreviousYear(date, 10);
	    case 'month':
	      return getBeginOfPreviousMonth(date, 12);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	var getBeginNext2 = exports.getBeginNext2 = function getBeginNext2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getBeginOfNextDecade(date, 100);
	    case 'year':
	      return getBeginOfNextYear(date, 10);
	    case 'month':
	      return getBeginOfNextMonth(date, 12);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	/**
	 * Returns the end of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	var getEnd = exports.getEnd = function getEnd(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getEndOfCentury(date);
	    case 'decade':
	      return getEndOfDecade(date);
	    case 'year':
	      return getEndOfYear(date);
	    case 'month':
	      return getEndOfMonth(date);
	    case 'day':
	      return getEndOfDay(date);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	var getEndPrevious = exports.getEndPrevious = function getEndPrevious(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getEndOfPreviousCentury(date);
	    case 'decade':
	      return getEndOfPreviousDecade(date);
	    case 'year':
	      return getEndOfPreviousYear(date);
	    case 'month':
	      return getEndOfPreviousMonth(date);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	var getEndPrevious2 = exports.getEndPrevious2 = function getEndPrevious2(rangeType, date) {
	  switch (rangeType) {
	    case 'decade':
	      return getEndOfPreviousDecade(date, 100);
	    case 'year':
	      return getEndOfPreviousYear(date, 10);
	    case 'month':
	      return getEndOfPreviousMonth(date, 12);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	/**
	 * Returns an array with the beginning and the end of a given range.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date Date.
	 */
	var getRange = exports.getRange = function getRange(rangeType, date) {
	  switch (rangeType) {
	    case 'century':
	      return getCenturyRange(date);
	    case 'decade':
	      return getDecadeRange(date);
	    case 'year':
	      return getYearRange(date);
	    case 'month':
	      return getMonthRange(date);
	    case 'day':
	      return getDayRange(date);
	    default:
	      throw new Error('Invalid rangeType: ' + rangeType);
	  }
	};
	
	/**
	 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
	 *
	 * @param {String} rangeType Range type (e.g. 'day')
	 * @param {Date} date1 First date.
	 * @param {Date} date2 Second date.
	 */
	var getValueRange = exports.getValueRange = function getValueRange(rangeType, date1, date2) {
	  var rawNextValue = [date1, date2].sort(function (a, b) {
	    return a.getTime() > b.getTime();
	  });
	  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
	};
	
	/**
	 * Returns a number of days in a month of a given date.
	 *
	 * @param {Date} date Date.
	 */
	var getDaysInMonth = exports.getDaysInMonth = function getDaysInMonth(date) {
	  var year = getYear(date);
	  var monthIndex = getMonthIndex(date);
	  return new Date(year, monthIndex + 1, 0).getDate();
	};
	
	var toYearLabel = function toYearLabel(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      start = _ref2[0],
	      end = _ref2[1];
	
	  return getYear(start) + ' \u2013 ' + getYear(end);
	};
	
	/**
	 * Returns a string labelling a century of a given date.
	 * For example, for 2017 it will return 2001-2100.
	 *
	 * @param {Date|String|Number} date Date or a year as a string or as a number.
	 */
	var getCenturyLabel = exports.getCenturyLabel = function getCenturyLabel(date) {
	  return toYearLabel(getCenturyRange(date));
	};
	
	/**
	 * Returns a string labelling a century of a given date.
	 * For example, for 2017 it will return 2011-2020.
	 *
	 * @param {Date|String|Number} date Date or a year as a string or as a number.
	 */
	var getDecadeLabel = exports.getDecadeLabel = function getDecadeLabel(date) {
	  return toYearLabel(getDecadeRange(date));
	};
	
	/**
	 * Returns a boolean determining whether a given date is on Saturday or Sunday.
	 *
	 * @param {Date} date Date.
	 */
	var isWeekend = exports.isWeekend = function isWeekend(date) {
	  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
	
	  var weekday = date.getDay();
	  switch (calendarType) {
	    case 'Arabic':
	    case 'Hebrew':
	      return weekday === FRIDAY || weekday === SATURDAY;
	    case 'ISO 8601':
	    case 'US':
	      return weekday === SATURDAY || weekday === SUNDAY;
	    default:
	      throw new Error('Unsupported calendar type.');
	  }
	};
	
	/**
	 * Returns local month in ISO-like format (YYYY-MM).
	 */
	var getISOLocalMonth = exports.getISOLocalMonth = function getISOLocalMonth(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error('Invalid date: ' + value);
	  }
	
	  var year = getYear(date);
	  var month = ('0' + getMonth(date)).slice(-2);
	
	  return year + '-' + month;
	};
	
	/**
	 * Returns local date in ISO-like format (YYYY-MM-DD).
	 */
	var getISOLocalDate = exports.getISOLocalDate = function getISOLocalDate(value) {
	  if (!value) {
	    return value;
	  }
	
	  var date = new Date(value);
	
	  if (isNaN(date.getTime())) {
	    throw new Error('Invalid date: ' + value);
	  }
	
	  var year = getYear(date);
	  var month = ('0' + getMonth(date)).slice(-2);
	  var day = ('0' + getDay(date)).slice(-2);
	
	  return year + '-' + month + '-' + day;
	};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
	var allViews = ['century', 'decade', 'year', 'month'];
	
	var isCalendarType = exports.isCalendarType = _propTypes2.default.oneOf(calendarTypes);
	
	var isMinDate = exports.isMinDate = function isMinDate(props, propName, componentName) {
	  var minDate = props[propName];
	
	
	  if (minDate) {
	    if (!(minDate instanceof Date)) {
	      return new Error('Invalid prop `' + propName + '` of type `' + (typeof minDate === 'undefined' ? 'undefined' : _typeof(minDate)) + '` supplied to `' + componentName + '`, expected instance of `Date`.');
	    }
	
	    var maxDate = props.maxDate;
	
	
	    if (maxDate && minDate > maxDate) {
	      return new Error('Invalid prop `' + propName + '` of type `' + (typeof minDate === 'undefined' ? 'undefined' : _typeof(minDate)) + '` supplied to `' + componentName + '`, minDate cannot be larger than maxDate.');
	    }
	  }
	
	  // Everything is fine
	  return null;
	};
	
	var isMaxDate = exports.isMaxDate = function isMaxDate(props, propName, componentName) {
	  var maxDate = props[propName];
	
	
	  if (maxDate) {
	    if (!(maxDate instanceof Date)) {
	      return new Error('Invalid prop `' + propName + '` of type `' + (typeof maxDate === 'undefined' ? 'undefined' : _typeof(maxDate)) + '` supplied to `' + componentName + '`, expected instance of `Date`.');
	    }
	
	    var minDate = props.minDate;
	
	
	    if (minDate && maxDate < minDate) {
	      return new Error('Invalid prop `' + propName + '` of type `' + (typeof maxDate === 'undefined' ? 'undefined' : _typeof(maxDate)) + '` supplied to `' + componentName + '`, maxDate cannot be smaller than minDate.');
	    }
	  }
	
	  // Everything is fine
	  return null;
	};
	
	var isValue = exports.isValue = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date))]);
	
	var isViews = exports.isViews = _propTypes2.default.arrayOf(_propTypes2.default.oneOf(allViews));
	
	var isClassName = exports.isClassName = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]);
	
	var isView = exports.isView = function isView(props, propName, componentName) {
	  var view = props[propName];
	  var views = props.views;
	
	
	  var allowedViews = views || allViews;
	
	  if (allowedViews.indexOf(view) === -1) {
	    return new Error('Invalid prop `' + propName + '` of value `' + view + '` supplied to `' + componentName + '`, expected one of [' + ['a', 'b', 'c', 'd', 'e'].map(function (a) {
	      return '"' + a + '"';
	    }).join(', ') + '].');
	  }
	
	  // Everything is fine
	  return null;
	};
	
	isView.isRequired = function (props, propName, componentName) {
	  var view = props[propName];
	
	
	  if (!view) {
	    return new Error('The prop `' + propName + '` is marked as required in `' + componentName + '`, but its value is `' + view + '`.');
	  }
	
	  return isView(props, propName, componentName);
	};
	
	var tileGroupProps = exports.tileGroupProps = {
	  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
	  hover: _propTypes2.default.instanceOf(Date),
	  maxDate: isMaxDate,
	  minDate: isMinDate,
	  onClick: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  tileClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, isClassName]),
	  tileContent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  value: isValue,
	  valueType: _propTypes2.default.string
	};
	
	var tileProps = exports.tileProps = {
	  classes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  date: _propTypes2.default.instanceOf(Date).isRequired,
	  maxDate: isMaxDate,
	  minDate: isMinDate,
	  onClick: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	  tileClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, isClassName]),
	  tileContent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  tileDisabled: _propTypes2.default.func
	};

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = undefined;
	
	var _dates = __webpack_require__(24);
	
	/**
	 * Returns a function that, when called, calls all the functions
	 * passed to it, applying its arguments to them.
	 *
	 * @param {Function[]} functions
	 */
	var mergeFunctions = exports.mergeFunctions = function mergeFunctions() {
	  for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
	    functions[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return functions.filter(Boolean).forEach(function (f) {
	      return f.apply(undefined, args);
	    });
	  };
	};
	
	/**
	 * Calls a function, if it's defined, with specified arguments
	 * @param {Function} fn
	 * @param {Object} args
	 */
	var callIfDefined = exports.callIfDefined = function callIfDefined(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  if (fn && typeof fn === 'function') {
	    fn.apply(undefined, args);
	  }
	};
	
	var isValueWithinRange = exports.isValueWithinRange = function isValueWithinRange(value, range) {
	  return range[0] <= value && range[1] >= value;
	};
	
	var isRangeWithinRange = exports.isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
	  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
	};
	
	var doRangesOverlap = exports.doRangesOverlap = function doRangesOverlap(range1, range2) {
	  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
	};
	
	/**
	 * Returns a value no smaller than min and no larger than max.
	 *
	 * @param {*} value Value to return.
	 * @param {*} min Minimum return value.
	 * @param {*} max Maximum return value.
	 */
	var between = exports.between = function between(value, min, max) {
	  if (min && min > value) {
	    return min;
	  }
	  if (max && max < value) {
	    return max;
	  }
	  return value;
	};
	
	var isEqual = function isEqual(date1, date2) {
	  return new Date(date1).getTime() === new Date(date2).getTime();
	};
	
	var getTileClasses = exports.getTileClasses = function getTileClasses() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      value = _ref.value,
	      valueType = _ref.valueType,
	      date = _ref.date,
	      dateType = _ref.dateType,
	      hover = _ref.hover;
	
	  var className = 'react-calendar__tile';
	  var classes = [className];
	
	  if (!date) {
	    return classes;
	  }
	
	  if (!(date instanceof Array) && !dateType) {
	    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
	  }
	
	  var now = new Date();
	  var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);
	
	  if (isValueWithinRange(now, dateRange)) {
	    classes.push(className + '--now');
	  }
	
	  if (!value) {
	    return classes;
	  }
	
	  if (!(value instanceof Array) && !valueType) {
	    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
	  }
	
	  var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);
	
	  if (isRangeWithinRange(valueRange, dateRange)) {
	    classes.push(className + '--active');
	  } else if (doRangesOverlap(valueRange, dateRange)) {
	    classes.push(className + '--hasActive');
	  } else if (hover && (
	  // Date before value
	  dateRange[1] < valueRange[0] && isRangeWithinRange([hover, valueRange[0]], dateRange) ||
	  // Date after value
	  dateRange[0] > valueRange[1] && isRangeWithinRange([valueRange[1], hover], dateRange))) {
	    classes.push(className + '--hover');
	  }
	
	  var isRangeStart = isEqual(dateRange[0], valueRange[0]);
	  var isRangeEnd = isEqual(dateRange[1], valueRange[1]);
	
	  if (isRangeStart) {
	    classes.push(className + '--rangeStart');
	  }
	
	  if (isRangeEnd) {
	    classes.push(className + '--rangeEnd');
	  }
	
	  if (isRangeStart && isRangeEnd) {
	    classes.push(className + '--rangeBothEnds');
	  }
	
	  return classes;
	};

/***/ }),

/***/ 1493:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: white;\n  height: 320px;\n  margin-bottom: 14px;\n  padding: 40px 20px;\n  position: relative;\n  ', '\n  p, strong {\n    font-size: 1.5rem;\n    line-height: 2rem;\n    text-transform: uppercase;\n    ', '\n  }\n  p {\n    font-weight: normal;\n  }\n  > * {\n    z-index: 1;\n  }\n  &:before {\n    background-color: ', ';\n    content: \'\';\n    height: 100%;\n    left: 0;\n    mix-blend-mode: overlay;\n    opacity: .5;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 0;\n  }\n  &:after {\n    background-color: ', ';\n    bottom: -14px;\n    content: \'\';\n    height: 7px;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n  }\n\n  ', '\n\n'], ['\n  background-color: ', ';\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: white;\n  height: 320px;\n  margin-bottom: 14px;\n  padding: 40px 20px;\n  position: relative;\n  ', '\n  p, strong {\n    font-size: 1.5rem;\n    line-height: 2rem;\n    text-transform: uppercase;\n    ', '\n  }\n  p {\n    font-weight: normal;\n  }\n  > * {\n    z-index: 1;\n  }\n  &:before {\n    background-color: ', ';\n    content: \'\';\n    height: 100%;\n    left: 0;\n    mix-blend-mode: overlay;\n    opacity: .5;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 0;\n  }\n  &:after {\n    background-color: ', ';\n    bottom: -14px;\n    content: \'\';\n    height: 7px;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n  }\n\n  ', '\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    background-position: 100% 35%;\n    background-repeat: no-repeat;\n    background-size: 110% auto;\n  '], ['\n    background-position: 100% 35%;\n    background-repeat: no-repeat;\n    background-size: 110% auto;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      font-size: 3rem;\n      line-height: 3.5rem;\n    '], ['\n      font-size: 3rem;\n      line-height: 3.5rem;\n    ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _style = __webpack_require__(4);
	
	var _biglietteria = __webpack_require__(193);
	
	var _biglietteria2 = _interopRequireDefault(_biglietteria);
	
	var _Grid = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _Grid.Row.extend(_templateObject, _style.colors.gray, _style.media.medium(_templateObject2), _style.media.medium(_templateObject3), _style.colors.red, _style.colors.red, function (_ref) {
	  var image = _ref.image;
	
	  if (image) {
	    return 'background-image: url(\'' + image + '\');';
	  }
	});
	
	var Banner = function Banner(_ref2) {
	  var children = _ref2.children;
	  return _react2.default.createElement(
	    Wrapper,
	    { image: _biglietteria2.default, shrink: 1 },
	    children
	  );
	};
	
	Banner.propTypes = {
	  children: _propTypes2.default.element.isRequired
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 20px 0 0;\n'], ['\n  padding: 20px 0 0;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.3rem;\n  font-weight: bold;\n  margin: 0;\n  text-transform: uppercase;\n'], ['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.3rem;\n  font-weight: bold;\n  margin: 0;\n  text-transform: uppercase;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 1.4rem;\n  line-height: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  margin: 20px 0 0;\n'], ['\n  font-size: 1.4rem;\n  line-height: 1.4rem;\n  font-weight: normal;\n  text-transform: uppercase;\n  margin: 20px 0 0;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.3rem;\n  font-weight: normal;\n  margin: 0;\n  text-transform: uppercase;\n'], ['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.3rem;\n  font-weight: normal;\n  margin: 0;\n  text-transform: uppercase;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  ', '\n  color: ', ';\n  font-weight: bold;\n'], ['\n  ', '\n  color: ', ';\n  font-weight: bold;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  ', '\n  color: ', ';\n  font-weight: normal;\n'], ['\n  ', '\n  color: ', ';\n  font-weight: normal;\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  margin: 40px 0;\n  flex-basis: 40%;\n  ', '\n'], ['\n  margin: 40px 0;\n  flex-basis: 40%;\n  ', '\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    margin: 0 50px 0 0;\n  '], ['\n    margin: 0 50px 0 0;\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  flex-basis: 60%;\n'], ['\n  flex-basis: 60%;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIdSwiper = __webpack_require__(28);
	
	var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);
	
	var _reactMarkdown = __webpack_require__(21);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _style = __webpack_require__(4);
	
	var _site = __webpack_require__(10);
	
	var _utils = __webpack_require__(17);
	
	var _Grid = __webpack_require__(5);
	
	var _Image = __webpack_require__(14);
	
	var _Button = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var config = {
	  spaceBetween: 40,
	  slidesPerView: 1,
	  shouldSwiperUpdate: true,
	  pagination: {
	    el: '.swiper-pagination.swiper-pagination--calendar',
	    type: 'bullets',
	    clickable: true
	  }
	};
	
	var Wrapper = _Grid.Column.extend(_templateObject, _style.media.medium(_templateObject2));
	
	var Content = (0, _styledComponents2.default)(_Grid.Column).attrs({
	  grow: 0
	})(_templateObject3);
	
	var Title = _styledComponents2.default.h3(_templateObject4, _style.colors.red);
	
	var Date = Title.extend(_templateObject5);
	
	var Subtitle = _styledComponents2.default.h4(_templateObject6, _style.colors.red);
	
	var fontStyle = '\n  font-size: .89rem;\n  line-height: 1.4rem;\n';
	
	var Label = _styledComponents2.default.span(_templateObject7, fontStyle, _style.colors.gray);
	
	var Text = _styledComponents2.default.span(_templateObject8, fontStyle, _style.colors.gray);
	
	var FirstColumn = _Grid.Column.extend(_templateObject9, _style.media.medium(_templateObject10));
	
	var SecondColumn = _Grid.Column.extend(_templateObject11);
	
	var CalendarPreview = function CalendarPreview(_ref) {
	  var data = _ref.data;
	
	  if (!data || !data.length) {
	    return _react2.default.createElement(
	      _Grid.Column,
	      { align: _style.flex.align.CENTER, justify: _style.flex.justify.CENTER },
	      _react2.default.createElement(
	        Title,
	        null,
	        'Nessun Evento nella data selezionata'
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _Grid.Column,
	    { grow: 0 },
	    _react2.default.createElement(
	      _reactIdSwiper2.default,
	      _extends({}, config, { pagination: config.pagination }),
	      data.map(function (_ref2, index) {
	        var content = _ref2.content,
	            image = _ref2.image,
	            date = _ref2.date,
	            link = _ref2.link,
	            officetime = _ref2.officetime,
	            subtitle = _ref2.subtitle,
	            title = _ref2.title,
	            slug = _ref2.slug;
	        return _react2.default.createElement(
	          'div',
	          { key: index },
	          _react2.default.createElement(
	            Wrapper,
	            null,
	            _react2.default.createElement(
	              FirstColumn,
	              { align: _style.flex.align.CENTER, shrink: 1 },
	              _react2.default.createElement(_Image.RoundImage, { disableLazy: true, src: image }),
	              _react2.default.createElement(
	                Date,
	                null,
	                (0, _utils.getDate)(date)
	              )
	            ),
	            _react2.default.createElement(
	              SecondColumn,
	              { shrink: 1 },
	              _react2.default.createElement(
	                Title,
	                null,
	                title
	              ),
	              _react2.default.createElement(
	                Subtitle,
	                null,
	                subtitle
	              ),
	              _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(
	                  Text,
	                  null,
	                  _react2.default.createElement(_reactMarkdown2.default, { source: content.substring(0, 200) + '...' })
	                )
	              ),
	              _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(
	                  Label,
	                  null,
	                  'Orario uffici'
	                ),
	                _react2.default.createElement(
	                  Text,
	                  null,
	                  officetime
	                )
	              ),
	              _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: link, target: '_blank' },
	                  _react2.default.createElement(
	                    _Button.BuyButton,
	                    null,
	                    'Acquista'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                Content,
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { href: (0, _utils.getHashedPath)(_site.pages.SPETTACOLI.link, slug) },
	                  _react2.default.createElement(
	                    _Button.ShowMoreButton,
	                    null,
	                    'Scopri di più >>'
	                  )
	                )
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = CalendarPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 40px 20px;\n  '], ['\n    padding: 40px 20px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  padding: 30px 10px;\n  flex-wrap: wrap;\n  ', '\n'], ['\n  padding: 30px 10px;\n  flex-wrap: wrap;\n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    padding: 30px;\n    border: 2px solid ', ';\n  '], ['\n    padding: 30px;\n    border: 2px solid ', ';\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 10px;\n  ', '\n'], ['\n  padding: 10px;\n  ', '\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    padding: 20px 40px 0;\n  '], ['\n    padding: 20px 40px 0;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin: 0 auto;\n  ', '\n'], ['\n  width: 100%;\n  margin: 0 auto;\n  ', '\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    flex-basis: 500px;\n  '], ['\n    flex-basis: 500px;\n  ']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  flex-basis: 100%;\n  ', '\n'], ['\n  flex-basis: 100%;\n  ', '\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    flex-basis: calc( 100% - 500px );\n  '], ['\n    flex-basis: calc( 100% - 500px );\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _entry = __webpack_require__(1424);
	
	var _entry2 = _interopRequireDefault(_entry);
	
	__webpack_require__(315);
	
	var _style = __webpack_require__(4);
	
	var _utils = __webpack_require__(17);
	
	var _Grid = __webpack_require__(5);
	
	var _CalendarPreview = __webpack_require__(313);
	
	var _CalendarPreview2 = _interopRequireDefault(_CalendarPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _Grid.Column.extend(_templateObject, _style.media.medium(_templateObject2));
	
	var Inner = _Grid.Row.extend(_templateObject3, _style.media.medium(_templateObject4, _style.colors.red));
	
	var Events = _Grid.Column.extend(_templateObject5, _style.media.medium(_templateObject6));
	
	var ColumnCalendar = _Grid.Column.extend(_templateObject7, _style.media.large(_templateObject8));
	
	var ColumnCalendarInfo = _Grid.Column.extend(_templateObject9, _style.media.wide(_templateObject10));
	
	var PrevLabel = function PrevLabel() {
	  return _react2.default.createElement(
	    'svg',
	    { width: '26', height: '51', viewBox: '0 0 26 51', fill: 'none' },
	    _react2.default.createElement('path', { d: 'M25.3933 50.2475L0.368408 25.042L25.3933 0.0045166V50.2475Z', fill: '#D72027' })
	  );
	};
	
	var NextLabel = function NextLabel() {
	  return _react2.default.createElement(
	    'svg',
	    { width: '26', height: '51', viewBox: '0 0 26 51', fill: 'none' },
	    _react2.default.createElement('path', { d: 'M0.591064 0.0045166L25.616 25.042L0.591064 50.2475V0.0045166Z', fill: '#D72027' })
	  );
	};
	
	var CalendarSection = function (_Component) {
	  _inherits(CalendarSection, _Component);
	
	  function CalendarSection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CalendarSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      events: (0, _utils.getEventsGroupped)(_this.props.data),
	      date: new Date()
	    }, _this.onChange = function (date) {
	      return _this.setState({ date: date });
	    }, _this.getTileClassName = function (_ref) {
	      var date = _ref.date;
	      var events = _this.state.events;
	
	
	      var dates = Object.keys(events).reduce(function (_, eventDate) {
	        return [].concat(_, [{
	          date: new Date((0, _utils.convertDate)(eventDate)),
	          gray: events[eventDate].gray
	        }]);
	      }, []);
	
	      var filteredDates = dates.filter(function (_ref2) {
	        var eventDate = _ref2.date;
	        return eventDate.getTime() === date.getTime();
	      });
	
	      if (filteredDates.length === 0) return 'customTile';
	
	      var hasEventRed = !!filteredDates.filter(function (_ref3) {
	        var gray = _ref3.gray;
	        return !gray;
	      }).length;
	      var hasEventGray = !!filteredDates.filter(function (_ref4) {
	        var gray = _ref4.gray;
	        return gray;
	      }).length;
	
	      if (hasEventRed && hasEventGray) return 'customTile customTile--hasEvent customTile--hasMultipleEvent';
	
	      if (hasEventRed) return 'customTile customTile--hasEvent customTile--hasEventRed';
	
	      if (hasEventGray) return 'customTile customTile--hasEvent customTile--hasEventGray';
	
	      return 'customTile';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CalendarSection.prototype.render = function render() {
	    var _state = this.state,
	        date = _state.date,
	        events = _state.events;
	
	
	    var currentKey = date.getFullYear() + '-' + (0, _utils.pad)(date.getMonth() + 1) + '-' + (0, _utils.pad)(date.getDate());
	
	    var currentEvents = events[currentKey];
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        Inner,
	        null,
	        _react2.default.createElement(
	          ColumnCalendar,
	          { grow: 0 },
	          _react2.default.createElement(_entry2.default, {
	            onChange: this.onChange,
	            onActiveDateChange: this.onChangeMonth,
	            tileClassName: this.getTileClassName,
	            prevLabel: _react2.default.createElement(PrevLabel, null),
	            nextLabel: _react2.default.createElement(NextLabel, null),
	            locale: 'it-IT',
	            showNeighboringMonth: false
	          })
	        ),
	        _react2.default.createElement(
	          ColumnCalendarInfo,
	          { grow: 0 },
	          _react2.default.createElement(
	            Events,
	            null,
	            _react2.default.createElement(_CalendarPreview2.default, { data: currentEvents })
	          )
	        )
	      )
	    );
	  };
	
	  return CalendarSection;
	}(_react.Component);
	
	CalendarSection.propTypes = {
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = CalendarSection;
	module.exports = exports['default'];

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  .react-calendar {\n    border: 1px solid ', ';\n    color: ', ';\n    user-select: none;\n    button[type=button] {\n      outline: none;\n      background-color: white;\n      border: none;\n      color: ', ';\n    }\n  }\n  .react-calendar__navigation {\n    border-bottom: 1px solid ', ';\n    padding: 4px 0;\n    .react-calendar__navigation__label {\n      font-size: 1.8rem;\n      pointer-events: none;\n    }\n  }\n  .react-calendar__month-view {\n    padding: 15px 10px 0;\n  }\n  .react-calendar__navigation__arrow {\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    text-align: center;\n    svg {\n      height: 100%;\n\n    }\n  }\n  .react-calendar__navigation__prev2-button {\n    display: none;\n  }\n  .react-calendar__navigation__next2-button {\n    display: none;\n  }\n\n  .react-calendar__month-view__weekdays {\n    margin-bottom: 10px;\n    text-align: center;\n    font-weight: bold;\n  }\n\n  .react-calendar__month-view  {\n    height: 400px;\n  }\n\n  button[type=button].react-calendar__tile {\n    cursor: pointer;\n    font-weight: bold;\n    height: 36px;\n    margin-bottom: 20px;\n    position: relative;\n    white-space: nowrap;\n\n    &.react-calendar__tile--active:before {\n      border-width: 3px!important;\n    }\n\n    &.customTile {\n      position: relative;\n      > time {\n        position: relative;\n      }\n\n      &:before {\n        position: absolute;\n        content: \'\';\n        width: 35px;\n        height: 35px;\n        border: 1px solid ', ';\n        border-radius: 50%;\n        left: 50%\n        top: 0;\n        transform: translateX(-50%);\n      }\n      &.customTile--hasEvent {\n        color: white;\n      }\n      &.customTile--hasEventRed:before{\n        background-color: ', ';\n        border-width: 0px;\n      }\n      &.customTile--hasEventGray:before{\n        background-color: ', ';\n        border-width: 0px;\n      }\n      &.customTile--hasMultipleEvent:before{\n        background: linear-gradient(to right, ', ' 50%, ', ' 50%);\n        border-width: 0px;\n      }\n    }\n  }\n'], ['\n  .react-calendar {\n    border: 1px solid ', ';\n    color: ', ';\n    user-select: none;\n    button[type=button] {\n      outline: none;\n      background-color: white;\n      border: none;\n      color: ', ';\n    }\n  }\n  .react-calendar__navigation {\n    border-bottom: 1px solid ', ';\n    padding: 4px 0;\n    .react-calendar__navigation__label {\n      font-size: 1.8rem;\n      pointer-events: none;\n    }\n  }\n  .react-calendar__month-view {\n    padding: 15px 10px 0;\n  }\n  .react-calendar__navigation__arrow {\n    width: 40px;\n    height: 40px;\n    cursor: pointer;\n    text-align: center;\n    svg {\n      height: 100%;\n\n    }\n  }\n  .react-calendar__navigation__prev2-button {\n    display: none;\n  }\n  .react-calendar__navigation__next2-button {\n    display: none;\n  }\n\n  .react-calendar__month-view__weekdays {\n    margin-bottom: 10px;\n    text-align: center;\n    font-weight: bold;\n  }\n\n  .react-calendar__month-view  {\n    height: 400px;\n  }\n\n  button[type=button].react-calendar__tile {\n    cursor: pointer;\n    font-weight: bold;\n    height: 36px;\n    margin-bottom: 20px;\n    position: relative;\n    white-space: nowrap;\n\n    &.react-calendar__tile--active:before {\n      border-width: 3px!important;\n    }\n\n    &.customTile {\n      position: relative;\n      > time {\n        position: relative;\n      }\n\n      &:before {\n        position: absolute;\n        content: \'\';\n        width: 35px;\n        height: 35px;\n        border: 1px solid ', ';\n        border-radius: 50%;\n        left: 50%\n        top: 0;\n        transform: translateX(-50%);\n      }\n      &.customTile--hasEvent {\n        color: white;\n      }\n      &.customTile--hasEventRed:before{\n        background-color: ', ';\n        border-width: 0px;\n      }\n      &.customTile--hasEventGray:before{\n        background-color: ', ';\n        border-width: 0px;\n      }\n      &.customTile--hasMultipleEvent:before{\n        background: linear-gradient(to right, ', ' 50%, ', ' 50%);\n        border-width: 0px;\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(6);
	
	var _style = __webpack_require__(4);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, _style.colors.red, _style.colors.red, _style.colors.red, _style.colors.red, _style.colors.red, _style.colors.red, _style.colors.gray, _style.colors.red, _style.colors.gray);

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 24px;\n  height: 24px;\n  display: block;\n  margin-bottom: 0;\n'], ['\n  width: 24px;\n  height: 24px;\n  display: block;\n  margin-bottom: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: none;\n  position: absolute;\n  left: 2rem;\n  width: 8rem;\n  font-size: 12px;\n  color: ', ';\n  text-align: left;\n  line-height: 15px;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n'], ['\n  display: none;\n  position: absolute;\n  left: 2rem;\n  width: 8rem;\n  font-size: 12px;\n  color: ', ';\n  text-align: left;\n  line-height: 15px;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  margin: 0 0 0 24px;\n  &:hover ', ' {\n    display: -webkit-box;\n  }\n'], ['\n  position: relative;\n  margin: 0 0 0 24px;\n  &:hover ', ' {\n    display: -webkit-box;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var CategoryImg = _styledComponents2.default.img(_templateObject);
	
	var CategoryLabel = _styledComponents2.default.div(_templateObject2, _style.colors.gray);
	
	var Container = _styledComponents2.default.div(_templateObject3, CategoryLabel);
	
	var CategoryBall = function CategoryBall(_ref) {
	  var src = _ref.src,
	      alt = _ref.alt;
	
	  return src && alt ? _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      CategoryLabel,
	      null,
	      alt
	    ),
	    _react2.default.createElement(CategoryImg, { src: src, alt: alt })
	  ) : null;
	};
	
	exports.default = CategoryBall;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 20px 40px;\n  justify-content: flex-end;\n\n  ', ' a {\n    text-decoration: none;\n    margin-left: 10px;\n  }\n'], ['\n  padding: 20px 40px;\n  justify-content: flex-end;\n\n  ', ' a {\n    text-decoration: none;\n    margin-left: 10px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 0 40px;\n  '], ['\n    padding: 0 40px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 40px;\n  height: 40px;\n  svg {\n    width: 100%;\n  }\n'], ['\n  width: 40px;\n  height: 40px;\n  svg {\n    width: 100%;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  ', ' text-decoration: none;\n  align-items: center;\n  justify-content: center;\n  font-weight: 100;\n'], ['\n  ', ' text-decoration: none;\n  align-items: center;\n  justify-content: center;\n  font-weight: 100;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(4);
	
	var _Grid = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _Grid.Row.extend(_templateObject, _style.media.medium(_templateObject2));
	
	var IconWrapper = _Grid.Column.extend(_templateObject3);
	
	var Inner = _Grid.Row.extend(_templateObject4, _style.cssFont.text);
	
	var Icon = function Icon() {
	  return _react2.default.createElement(
	    IconWrapper,
	    null,
	    _react2.default.createElement(
	      'svg',
	      { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 187.1 168' },
	      _react2.default.createElement('path', {
	        fill: _style.colors.red,
	        d: 'M124.2 76.5l-27.1 39.1h-7L62.9 76.5v-4.7h14.2l.3-38.7h32.7v38.7h14.1zM40.2 123.1h106.7v11.7H40.2z'
	      })
	    )
	  );
	};
	
	var Downloads = function Downloads() {
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: '/PACTASALONE_Cartellastampa_020-021_cop.pdf', download: true },
	      _react2.default.createElement(
	        Inner,
	        null,
	        _react2.default.createElement(Icon, null),
	        'Cartella Stampa'
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '/Locandina_stag_20_21_21x49_HR.pdf', download: true },
	      _react2.default.createElement(
	        Inner,
	        null,
	        _react2.default.createElement(Icon, null),
	        'Depliant'
	      )
	    )
	  );
	};
	
	exports.default = Downloads;
	module.exports = exports['default'];

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 40px;\n  flex-basis: 100%;\n  flex-wrap: wrap;\n  border-bottom: 1px solid ', ';\n  ', ' ', ';\n'], ['\n  padding: 40px;\n  flex-basis: 100%;\n  flex-wrap: wrap;\n  border-bottom: 1px solid ', ';\n  ', ' ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    border: none;\n    flex-basis: 50%;\n  '], ['\n    border: none;\n    flex-basis: 50%;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    flex-basis: 25%;\n  '], ['\n    flex-basis: 25%;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  padding: 20px 0 0;\n'], ['\n  padding: 20px 0 0;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 20px;\n  ', ';\n'], ['\n  margin-bottom: 20px;\n  ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  flex-basis: auto;\n  flex-direction: row;\n  ', ';\n'], ['\n  flex-basis: auto;\n  flex-direction: row;\n  ', ';\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    order: 2;\n  '], ['\n    order: 2;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 1rem;\n  font-weight: bold;\n  margin: 0;\n  margin-bottom: 1em;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n'], ['\n  color: ', ';\n  font-size: 1rem;\n  font-weight: bold;\n  margin: 0;\n  margin-bottom: 1em;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 1rem;\n  font-weight: normal;\n  margin: 0;\n'], ['\n  color: ', ';\n  font-size: 1rem;\n  font-weight: normal;\n  margin: 0;\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  ', '\n  color: ', ';\n  font-weight: bold;\n'], ['\n  ', '\n  color: ', ';\n  font-weight: bold;\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  ', '\n  color: ', ';\n'], ['\n  ', '\n  color: ', ';\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  height: 3em;\n'], ['\n  height: 3em;\n']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  height: 26px;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n'], ['\n  display: inline-flex;\n  height: 26px;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(4);
	
	var _site = __webpack_require__(10);
	
	var _Grid = __webpack_require__(5);
	
	var _Button = __webpack_require__(12);
	
	var _Image = __webpack_require__(14);
	
	var _utils = __webpack_require__(17);
	
	var _Nl2br = __webpack_require__(202);
	
	var _Nl2br2 = _interopRequireDefault(_Nl2br);
	
	var _CategoryBall = __webpack_require__(64);
	
	var _CategoryBall2 = _interopRequireDefault(_CategoryBall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _Grid.Column.extend(_templateObject, _style.colors.red, _style.media.medium(_templateObject2), _style.media.large(_templateObject3));
	
	var Content = (0, _styledComponents2.default)(_Grid.Column).attrs({
	  grow: 0,
	  shrink: 1
	})(_templateObject4);
	
	var ContentTitleSmall = Content.extend(_templateObject5, _style.media.medium(_templateObject6));
	
	var ContentTitleMedium = Content.extend(_templateObject7, _style.media.mediumDown(_templateObject6));
	
	var ContentButton = Content.extend(_templateObject8, _style.media.mediumDown(_templateObject9));
	
	var Title = _styledComponents2.default.h2(_templateObject10, _style.colors.red);
	
	var Subtitle = _styledComponents2.default.h3(_templateObject11, _style.colors.red);
	
	var fontStyle = '\n  font-size: .8rem;\n  line-height: 1rem;\n  text-transform: uppercase;\n';
	
	var Label = _styledComponents2.default.span(_templateObject12, fontStyle, _style.colors.gray);
	
	var Text = _styledComponents2.default.span(_templateObject13, fontStyle, _style.colors.gray);
	
	var ContentHourText = Text.extend(_templateObject14);
	
	var AImg = _styledComponents2.default.a(_templateObject15);
	
	var EventHomePage = function EventHomePage(_ref) {
	  var data = _ref.data;
	  var _data$node = data.node,
	      fields = _data$node.fields,
	      _data$node$frontmatte = _data$node.frontmatter,
	      image = _data$node$frontmatte.image,
	      link = _data$node$frontmatte.link,
	      showtime = _data$node$frontmatte.showtime,
	      subtitle = _data$node$frontmatte.subtitle,
	      title = _data$node$frontmatte.title;
	
	  var _getCategoryFromField = (0, _utils.getCategoryFromFields)(fields),
	      slug = _getCategoryFromField.slug,
	      _getCategoryFromField2 = _getCategoryFromField.category,
	      categorySlug = _getCategoryFromField2.fields.slug,
	      _getCategoryFromField3 = _getCategoryFromField2.frontmatter,
	      categoryTitle = _getCategoryFromField3.title,
	      categoryIcon = _getCategoryFromField3.icon,
	      categoryHidden = _getCategoryFromField3.hidden;
	
	  return _react2.default.createElement(
	    Wrapper,
	    { align: _style.flex.align.CENTER, grow: 0 },
	    _react2.default.createElement(
	      ContentTitleSmall,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        Subtitle,
	        null,
	        subtitle
	      )
	    ),
	    _react2.default.createElement(
	      _Grid.Column,
	      { grow: 0 },
	      _react2.default.createElement(_Image.RoundImage, { src: image })
	    ),
	    _react2.default.createElement(
	      _Grid.Column,
	      { grow: 0, shrink: 1 },
	      _react2.default.createElement(
	        ContentButton,
	        { grow: 1 },
	        _react2.default.createElement(
	          'a',
	          { href: link, target: '_blank' },
	          _react2.default.createElement(
	            _Button.BuyButton,
	            null,
	            'Acquista'
	          )
	        ),
	        !categoryHidden && _react2.default.createElement(
	          AImg,
	          { href: (0, _utils.getHashedPath)(_site.pages.PROGETTI.link, categorySlug) },
	          _react2.default.createElement(_CategoryBall2.default, { src: categoryIcon, alt: categoryTitle })
	        )
	      ),
	      _react2.default.createElement(
	        ContentTitleMedium,
	        { grow: 1 },
	        _react2.default.createElement(
	          Title,
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          Subtitle,
	          null,
	          subtitle
	        )
	      ),
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          Label,
	          null,
	          'Orario spettacoli'
	        ),
	        _react2.default.createElement(
	          ContentHourText,
	          null,
	          _react2.default.createElement(_Nl2br2.default, { source: showtime })
	        )
	      ),
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: (0, _utils.getHashedPath)(_site.pages.SPETTACOLI.link, slug) },
	          _react2.default.createElement(
	            _Button.ShowMoreButton,
	            null,
	            'Scopri di più  >>'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = EventHomePage;
	module.exports = exports['default'];

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100vh;\n  max-height: 1080px;\n  min-height: 600px;\n  position: relative;\n  margin-bottom: 120px;\n'], ['\n  height: 100vh;\n  max-height: 1080px;\n  min-height: 600px;\n  position: relative;\n  margin-bottom: 120px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-image: url("', '");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n'], ['\n  background-image: url("', '");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: white;\n  padding: 2rem;\n  position: absolute;\n  width: 100%;\n'], ['\n  color: white;\n  padding: 2rem;\n  position: absolute;\n  width: 100%;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 40px;\n'], ['\n  margin-bottom: 40px;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  color: white;\n  padding: 1rem;\n'], ['\n  color: white;\n  padding: 1rem;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  0%, 100% {\n    transform: translate3d(0, 0, 0);\n  }\n\n  50% {\n    transform: translate3d(0, 2px, 0);\n  }\n'], ['\n  0%, 100% {\n    transform: translate3d(0, 0, 0);\n  }\n\n  50% {\n    transform: translate3d(0, 2px, 0);\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  user-select: none;\n\n  /* div {\n    will-change: transform;\n    animation: ', ' .8s linear infinite;\n  } */\n  svg {\n    margin-top: 8px;\n  }\n'], ['\n  cursor: pointer;\n  user-select: none;\n\n  /* div {\n    will-change: transform;\n    animation: ', ' .8s linear infinite;\n  } */\n  svg {\n    margin-top: 8px;\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _style = __webpack_require__(4);
	
	var _site = __webpack_require__(10);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Grid = __webpack_require__(5);
	
	var _Logo = __webpack_require__(124);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _StickyHeader = __webpack_require__(334);
	
	var _StickyHeader2 = _interopRequireDefault(_StickyHeader);
	
	var _background = __webpack_require__(1590);
	
	var _background2 = _interopRequireDefault(_background);
	
	var _utils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeroWrapper = _Grid.Column.extend(_templateObject);
	
	var Background = _Grid.Column.extend(_templateObject2, _background2.default);
	
	var Header = _Grid.Row.extend(_templateObject3);
	
	var LogoWrapper = _Grid.Column.extend(_templateObject4);
	
	var Footer = _Grid.Column.extend(_templateObject5);
	
	var bouncing = (0, _styledComponents.keyframes)(_templateObject6);
	
	var ScrollDown = _Grid.Column.extend(_templateObject7, bouncing);
	
	var Hero = function (_Component) {
	  _inherits(Hero, _Component);
	
	  function Hero() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.hero = {
	      component: null,
	      height: 0
	    }, _this.getHero = function (ref) {
	      return _this.hero.component = ref;
	    }, _this.getHeroHeight = function () {
	      _this.hero.height = _this.hero.component.offsetHeight;
	    }, _this.scrollDown = function () {
	      (0, _utils.scrollTo)(_this.hero.height, null, 700);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Hero.prototype.componentDidMount = function componentDidMount() {
	    this.getHeroHeight();
	  };
	
	  Hero.prototype.render = function render() {
	    var _props = this.props,
	        onMenuClick = _props.onMenuClick,
	        onCalendarClick = _props.onCalendarClick;
	
	
	    return _react2.default.createElement(
	      HeroWrapper,
	      { innerRef: this.getHero },
	      _react2.default.createElement(
	        Header,
	        { align: _style.flex.align.CENTER, justify: _style.flex.justify.END },
	        _react2.default.createElement(_Button.MenuButton, { onClick: onMenuClick })
	      ),
	      _react2.default.createElement(
	        Background,
	        null,
	        _react2.default.createElement(
	          _Grid.Column,
	          { align: _style.flex.align.CENTER, justify: _style.flex.justify.CENTER },
	          _react2.default.createElement(
	            LogoWrapper,
	            {
	              align: _style.flex.align.CENTER,
	              grow: 0,
	              justify: _style.flex.justify.CENTER
	            },
	            _react2.default.createElement(_Logo2.default, null)
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: _site.pages.BIGLIETTERIA.link },
	            _react2.default.createElement(
	              _Button2.default,
	              null,
	              'BIGLIETTERIA'
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { style: { marginTop: '2em' }, onClick: onCalendarClick },
	            'CALENDARIO'
	          )
	        ),
	        _react2.default.createElement(
	          Footer,
	          {
	            grow: 0,
	            align: _style.flex.align.CENTER,
	            justify: _style.flex.justify.CENTER
	          },
	          _react2.default.createElement(
	            ScrollDown,
	            {
	              onClick: this.scrollDown,
	              grow: 0,
	              align: _style.flex.align.CENTER,
	              justify: _style.flex.justify.CENTER
	            },
	            'Scroll Down',
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'svg',
	                { width: '37', height: '18', viewBox: '0 0 37 18', fill: 'none' },
	                _react2.default.createElement('path', {
	                  d: 'M1 1L18.027 16L36 1',
	                  stroke: 'white',
	                  strokeWidth: '2'
	                })
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_StickyHeader2.default, { onMenuClick: onMenuClick })
	    );
	  };
	
	  return Hero;
	}(_react.Component);
	
	Hero.defaultProps = {
	  onMenuClick: function onMenuClick() {}
	};
	
	Hero.propTypes = {
	  onMenuClick: _propTypes2.default.func
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  flex-wrap: wrap;\n  padding: 20px 0 0;\n  position: relative;\n  &:after {\n    background-color: ', ';\n    bottom: 0;\n    content: \'\';\n    height: 4px;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n  }\n  ', ' ', ';\n'], ['\n  flex-wrap: wrap;\n  padding: 20px 0 0;\n  position: relative;\n  &:after {\n    background-color: ', ';\n    bottom: 0;\n    content: \'\';\n    height: 4px;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n  }\n  ', ' ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding: 40px 0 0;\n  '], ['\n    padding: 40px 0 0;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    padding: 40px 40px 0;\n  '], ['\n    padding: 40px 40px 0;\n  ']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  flex-basis: 25%;\n  padding: ', ';\n  margin-bottom: 40px;\n  img {\n    margin: 0;\n    object-fit: contain;\n  }\n  ', ' ', ';\n'], ['\n  flex-basis: 25%;\n  padding: ', ';\n  margin-bottom: 40px;\n  img {\n    margin: 0;\n    object-fit: contain;\n  }\n  ', ' ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    flex-basis: 16%\n  '], ['\n    flex-basis: 16%\n  ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    flex-basis: 9%;\n  '], ['\n    flex-basis: 9%;\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _municipio = __webpack_require__(1618);
	
	var _municipio2 = _interopRequireDefault(_municipio);
	
	var _comune = __webpack_require__(1613);
	
	var _comune2 = _interopRequireDefault(_comune);
	
	var _invito = __webpack_require__(1615);
	
	var _invito2 = _interopRequireDefault(_invito);
	
	var _ministero = __webpack_require__(1617);
	
	var _ministero2 = _interopRequireDefault(_ministero);
	
	var _regione = __webpack_require__(1621);
	
	var _regione2 = _interopRequireDefault(_regione);
	
	var _guna = __webpack_require__(1614);
	
	var _guna2 = _interopRequireDefault(_guna);
	
	var _claps = __webpack_require__(1612);
	
	var _claps2 = _interopRequireDefault(_claps);
	
	var _vas = __webpack_require__(1622);
	
	var _vas2 = _interopRequireDefault(_vas);
	
	var _neglia = __webpack_require__(1619);
	
	var _neglia2 = _interopRequireDefault(_neglia);
	
	var _bauadvisor = __webpack_require__(1611);
	
	var _bauadvisor2 = _interopRequireDefault(_bauadvisor);
	
	var _metropolitana = __webpack_require__(1616);
	
	var _metropolitana2 = _interopRequireDefault(_metropolitana);
	
	var _oralegale = __webpack_require__(1620);
	
	var _oralegale2 = _interopRequireDefault(_oralegale);
	
	var _style = __webpack_require__(4);
	
	var _Grid = __webpack_require__(5);
	
	var _Title = __webpack_require__(342);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	// import camera from '../../../static/assets/images/partners/camera.jpg'
	// import xh from '../../../static/assets/images/partners/xh.jpg'
	
	
	var Inner = _Grid.Row.extend(_templateObject, _style.colors.red, _style.media.medium(_templateObject2), _style.media.large(_templateObject3));
	
	var Partner = (0, _styledComponents2.default)(_Grid.Column).attrs({
	  align: _style.flex.align.CENTER,
	  grow: 0,
	  justify: _style.flex.justify.CENTER
	})(_templateObject4, function (_ref) {
	  var padding = _ref.padding;
	  return padding ? padding : '0 1rem';
	}, _style.media.medium(_templateObject5), _style.media.large(_templateObject6));
	
	var Partners = function Partners() {
	  return _react2.default.createElement(
	    _Grid.Column,
	    null,
	    _react2.default.createElement(
	      _Title2.default,
	      null,
	      'Partners'
	    ),
	    _react2.default.createElement(
	      Inner,
	      { justify: _style.flex.justify.CENTER },
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            href: 'https://web.comune.milano.it/wps/portal/municipi/municipio_5'
	          },
	          _react2.default.createElement('img', { src: _municipio2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        { padding: '0' },
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.comune.milano.it/' },
	          _react2.default.createElement('img', { src: _comune2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.cittametropolitana.mi.it/' },
	          _react2.default.createElement('img', { src: _metropolitana2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'http://www.beniculturali.it/' },
	          _react2.default.createElement('img', { src: _ministero2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.invitoateatro.mi.it/' },
	          _react2.default.createElement('img', { src: _invito2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'http://claps.lombardia.it/' },
	          _react2.default.createElement('img', { src: _claps2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://guna.com/' },
	          _react2.default.createElement('img', { src: _guna2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        { padding: '0 1.6rem' },
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://vas.it/' },
	          _react2.default.createElement('img', { src: _vas2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.bauadvisor.it/' },
	          _react2.default.createElement('img', { src: _bauadvisor2.default })
	        )
	      ),
	      _react2.default.createElement(
	        Partner,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://www.oralegalenews.it/' },
	          _react2.default.createElement('img', { src: _oralegale2.default })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Partners;
	module.exports = exports['default'];

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: white;\n  border-bottom: 1px solid ', ';\n  height: 110px;\n  left: 0;\n  padding: 20px 40px;\n  position: ', ';\n  right: 0;\n  top: ', ';\n  transition: box-shadow .3s ease-in-out;\n  z-index: 100;\n'], ['\n  background-color: white;\n  border-bottom: 1px solid ', ';\n  height: 110px;\n  left: 0;\n  padding: 20px 40px;\n  position: ', ';\n  right: 0;\n  top: ', ';\n  transition: box-shadow .3s ease-in-out;\n  z-index: 100;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(4);
	
	var _Logo = __webpack_require__(124);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Button = __webpack_require__(12);
	
	var _Grid = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var sticky = _ref.sticky;
	  return sticky ? _style.colors.gray : 'transparent';
	}, function (_ref2) {
	  var sticky = _ref2.sticky;
	  return sticky ? 'fixed' : 'absolute';
	}, function (_ref3) {
	  var sticky = _ref3.sticky;
	  return sticky ? '0' : '100%';
	});
	
	var StickyHeader = function (_Component) {
	  _inherits(StickyHeader, _Component);
	
	  function StickyHeader() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StickyHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      sticky: false
	    }, _this.calculateStickyState = function () {
	
	      if (_this._rafExecuting) {
	        return;
	      }
	
	      _this._rafExecuting = true;
	
	      requestAnimationFrame(function () {
	
	        var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
	
	        if (scrollTop >= _this.wrapperOffsetTop && !_this.state.sticky) {
	          _this.setState({ sticky: true }, function () {
	            _this.props.onSticky(true);
	          });
	        } else if (scrollTop < _this.wrapperOffsetTop && _this.state.sticky) {
	          _this.setState({ sticky: false }, function () {
	            _this.props.onSticky(false);
	          });
	        }
	
	        _this._rafExecuting = false;
	      });
	    }, _this.saveTopWrapper = function () {
	      return _this.wrapperOffsetTop = _this.wrapper.offsetTop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StickyHeader.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('scroll', this.calculateStickyState);
	    this.saveTopWrapper();
	  };
	
	  StickyHeader.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('scroll', this.calculateStickyState);
	  };
	
	  StickyHeader.prototype.render = function render() {
	    var _this2 = this;
	
	    var sticky = this.state.sticky;
	    var onMenuClick = this.props.onMenuClick;
	
	
	    return _react2.default.createElement(
	      Wrapper,
	      { innerRef: function innerRef(node) {
	          return _this2.wrapper = node;
	        }, sticky: sticky },
	      _react2.default.createElement(
	        _Grid.Row,
	        { align: _style.flex.align.CENTER, justify: _style.flex.justify.SPACE_BETWEEN },
	        _react2.default.createElement(_Logo2.default, { colored: true, xsmall: true }),
	        _react2.default.createElement(_Button.MenuButton, { onClick: onMenuClick, red: true })
	      )
	    );
	  };
	
	  return StickyHeader;
	}(_react.Component);
	
	StickyHeader.defaultProps = {
	  onSticky: function onSticky() {}
	};
	
	StickyHeader.propTypes = {
	  onMenuClick: _propTypes2.default.func.isRequired,
	  onSticky: _propTypes2.default.func
	};
	
	exports.default = StickyHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 2rem;\n  font-weight: 100;\n  line-height: 2.5rem;\n  padding: 0 20px;\n  position: relative;\n  text-transform: uppercase;\n\n  ', '\n\n  &:after {\n    background-color: ', ';\n    bottom: .2rem;\n    content: \'\';\n    height: 7px;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n    ', '\n  }\n'], ['\n  color: ', ';\n  font-size: 2rem;\n  font-weight: 100;\n  line-height: 2.5rem;\n  padding: 0 20px;\n  position: relative;\n  text-transform: uppercase;\n\n  ', '\n\n  &:after {\n    background-color: ', ';\n    bottom: .2rem;\n    content: \'\';\n    height: 7px;\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    width: 100%;\n    ', '\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: 3rem;\n    line-height: 3.5rem;\n  '], ['\n    font-size: 3rem;\n    line-height: 3.5rem;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      bottom: .4rem;\n    '], ['\n      bottom: .4rem;\n    ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(4);
	
	var _Grid = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = (0, _styledComponents2.default)(_Grid.Column).attrs({
	  grow: 0
	})(_templateObject, _style.colors.red, _style.media.medium(_templateObject2), _style.colors.red, _style.media.medium(_templateObject3));
	
	var Title = function Title(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    children
	  );
	};
	
	Title.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]).isRequired
	};
	
	exports.default = Title;
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var image = exports.image = 'https://source.unsplash.com/random';
	
	var header = exports.header = __webpack_require__(196);
	
	exports.default = undefined;

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-bottom: 0px;\n  ', ';\n'], ['\n  padding-bottom: 0px;\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding-bottom: 40px;\n  '], ['\n    padding-bottom: 40px;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  flex-wrap: wrap;\n  ', ';\n'], ['\n  flex-wrap: wrap;\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 2rem;\n  font-weight: 100;\n  line-height: 2.5rem;\n  padding: 20px 40px;\n  ', ' strong {\n    color: ', ';\n    font-size: 2rem;\n    font-weight: bold;\n    line-height: 2.5rem;\n  }\n'], ['\n  color: ', ';\n  font-size: 2rem;\n  font-weight: 100;\n  line-height: 2.5rem;\n  padding: 20px 40px;\n  ', ' strong {\n    color: ', ';\n    font-size: 2rem;\n    font-weight: bold;\n    line-height: 2.5rem;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n    padding: 40px;\n  '], ['\n    flex-direction: row;\n    padding: 40px;\n  ']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  ', ' padding: 0 40px;\n'], ['\n  ', ' padding: 0 40px;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(113);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Banner = __webpack_require__(312);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Calendar = __webpack_require__(314);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Downloads = __webpack_require__(65);
	
	var _Downloads2 = _interopRequireDefault(_Downloads);
	
	var _EventHomepage = __webpack_require__(316);
	
	var _EventHomepage2 = _interopRequireDefault(_EventHomepage);
	
	var _Footer = __webpack_require__(16);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Hero = __webpack_require__(317);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Partners = __webpack_require__(320);
	
	var _Partners2 = _interopRequireDefault(_Partners);
	
	var _Button = __webpack_require__(12);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Grid = __webpack_require__(5);
	
	var _mock = __webpack_require__(343);
	
	var _site = __webpack_require__(10);
	
	var _style = __webpack_require__(4);
	
	var _Menu = __webpack_require__(18);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _utils = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var WrapperEvents = _Grid.Column.extend(_templateObject, _style.media.medium(_templateObject2));
	
	var InnerEvents = _Grid.Column.extend(_templateObject3, _style.media.medium(_templateObject4));
	
	var Title = _Grid.Column.extend(_templateObject5, _style.colors.red, _style.media.medium(_templateObject6), _style.colors.red);
	
	var Subtitle = _Grid.Column.extend(_templateObject7, _style.cssFont.title);
	
	var DownloadWrapper = _Grid.Column.extend(_templateObject8, _style.media.medium(_templateObject4));
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.calendarRef = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    sessionStorage.setItem('banner-visible', 'invisible');
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        data = _props.data,
	        toggleMenu = _props.toggleMenu;
	
	    var shows = data.allMarkdownRemark.edges;
	
	    var filteredShows = (0, _utils.filterPastEvents)(shows);
	
	    var bannerVisible = void 0;
	
	    if (typeof window !== 'undefined') {
	      bannerVisible = window.sessionStorage.getItem('banner-visible');
	    }
	
	    return _react2.default.createElement(
	      _Grid.Column,
	      null,
	      bannerVisible !== 'invisible' && _react2.default.createElement('div', { id: 'frm-mltchnl' }),
	      _react2.default.createElement(_Hero2.default, {
	        onMenuClick: toggleMenu,
	        onCalendarClick: function onCalendarClick() {
	          var node = _reactDom2.default.findDOMNode(_this2.calendarRef);
	          var rect = node.getBoundingClientRect();
	          (0, _utils.scrollTo)(rect.y - 100, null, 700);
	        }
	      }),
	      _react2.default.createElement(
	        WrapperEvents,
	        { grow: 0 },
	        _react2.default.createElement(
	          _Grid.Column,
	          null,
	          _react2.default.createElement(
	            Title,
	            null,
	            _site.pages.SPETTACOLI.title,
	            '\xA0',
	            _react2.default.createElement(
	              'strong',
	              null,
	              '|\xA0',
	              _site.pages.SPETTACOLI.seasonName
	            )
	          ),
	          _react2.default.createElement(
	            DownloadWrapper,
	            null,
	            _react2.default.createElement(
	              Subtitle,
	              null,
	              'Prossimi Appuntamenti'
	            ),
	            _react2.default.createElement(_Downloads2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          InnerEvents,
	          null,
	          filteredShows.length != 0 ? filteredShows.slice(0, 4).map(function (show, index) {
	            return _react2.default.createElement(_EventHomepage2.default, { key: index, data: show });
	          }) : _react2.default.createElement(
	            'p',
	            { style: { padding: '40px', fontWeight: 'bold' } },
	            'Gli spettacoli sono terminati e riprenderanno la prossima stagione!'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Banner2.default,
	        { image: _mock.image },
	        _react2.default.createElement(
	          _Grid.Column,
	          {
	            align: _style.flex.align.END,
	            justify: _style.flex.justify.CENTER,
	            shrink: 1
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Clicca qui e scopri di pi\xF9',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'sui nostri abbonamenti'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: _site.pages.BIGLIETTERIA.link },
	            _react2.default.createElement(
	              _Button2.default,
	              null,
	              'SCOPRI DI PI\xD9'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Calendar2.default, { data: shows, ref: function ref(cref) {
	          return _this2.calendarRef = cref;
	        } }),
	      _react2.default.createElement(_Partners2.default, null),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = (0, _Menu2.default)(IndexPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 1590:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/__background.f181b610.jpg";

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/biglietteria.d4482cc2.jpg";

/***/ }),

/***/ 1611:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bauadvisor.7ba5fc93.png";

/***/ }),

/***/ 1612:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/claps.72ac5c6c.png";

/***/ }),

/***/ 1613:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/comune.4e28cd30.jpg";

/***/ }),

/***/ 1614:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 1615:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/metropolitana.784c50e8.jpeg";

/***/ }),

/***/ 1617:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/municipio.8a4bfa61.png";

/***/ }),

/***/ 1619:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/oralegale.476b4deb.jpg";

/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/regione.f513fcec.jpg";

/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vas.d0ffb755.png";

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/red-curtain.673f3445.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-c9dbaf916e577d594acc.js